
import React, { useEffect, useState } from "react";
import {
  Plus,
  Trash2,
  Info,
  Upload,
  FileText,
  ExternalLink,
  Download,
  Search,
  X,
} from "lucide-react";
import Apiurl from "../environment/Apiurl";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

// ===================== code for speech to text ========================
// import React, { useState, useRef, useCallback, useEffect } from 'react';
// import { Mic, MicOff, Trash2, Copy, Check, AlertCircle } from 'lucide-react';
import { useRef, useCallback } from "react";
import { Mic, MicOff, Copy, Check, AlertCircle } from "lucide-react";
// ===================== code for speech to text ========================

const PrescriptionData = ({ togglesidebar }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [appointments, setAppointment] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [prescriptions, setPrescriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [medicineList, setMedicineList] = useState([]);
  const [medicineMaster, setMedicineMaster] = useState([]);
  const [stockPharmacy, setStockPharmacy] = useState([]);
  const [patientHistoryData, setPatientHistoryData] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [historySearchQuery, setHistorySearchQuery] = useState("");
  const [historyPageSize, setHistoryPageSize] = useState(5);
  const [historyCurrentPage, setHistoryCurrentPage] = useState(1);
  const [isMedicineCheckOpen, setIsMedicineCheckOpen] = useState(false);
  const [medicineCheckQuery, setMedicineCheckQuery] = useState("");
  const [medicineCheckResult, setMedicineCheckResult] = useState(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showPopupModal, setShowPopupModal] = useState(false);
  const [medicineSearch, setMedicineSearch] = useState("");
  const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
  const [isManualMedicineEntry, setIsManualMedicineEntry] = useState(false);

  // Patient Documents modal — opened from the Previous Visit History header
  // so documents can be uploaded/updated for the current appointment even
  // when the Clinical Assessment card is hidden (returning patient with
  // existing visit history).
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);

  // Patient quick search: autocomplete by Patient ID / Mobile / Name.
  // Selecting a patient and pressing Enter opens a separate read-only summary page.
  const [patientLookupQuery, setPatientLookupQuery] = useState("");
  const [patientLookupLoading, setPatientLookupLoading] = useState(false);
  const [patientLookupError, setPatientLookupError] = useState("");
  const [patientLookupResults, setPatientLookupResults] = useState([]);
  const [selectedLookupPatient, setSelectedLookupPatient] = useState(null);
  const [showPatientLookupDropdown, setShowPatientLookupDropdown] =
    useState(false);
  const [patientLookupActiveIndex, setPatientLookupActiveIndex] = useState(-1);

  const [prescriptionDocuments, setPrescriptionDocuments] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isUploadingDocuments, setIsUploadingDocuments] = useState(false);
  const [documentError, setDocumentError] = useState("");
  const [documentType, setDocumentType] = useState("");

  const [addData, setAddData] = useState({
    medicine_name: "",
    category: "",
    medicine_type: "",
    manufacturer: "",
    hsn_code: "",
    gst_percentage: "",
    unit: "",
    notes: "",
    status: "",
  });

  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    instruction: "",
    next_visit_date: "",
    next_visit_interval: "",
    medicine_name: "",
    available_qty: 0,
    price: "",
    dosage: "",
    duration: "",
    dose_type: "drops",
    sos: false,
    prescription_weight: "",
    prescription_bp: "",
    prescription_pulse: "",
    prescription_temperature: "",
    // Speech-to-text data is part of this page form state and is saved
    // separately in the backend against the current appointment/prescription.
    speech_language: "english",
    speech_transcript: "",
    direct: true,
    water: false,
    timing: {
      fn: { before: "0", after: "0", dose_type: "drops" },
      an: { before: "0", after: "0", dose_type: "drops" },
      night: { before: "0", after: "0", dose_type: "drops" },
    },
  });

  const [diagnosisData, setDiagnosisData] = useState({
    presenting_complaints: "",
    past_history: "",
    treatment_history: "",
    family_history: "",
    case_study: "",

    diet: "",
    appetite: "",
    thirst: "",
    bowel_habits: "",
    urination: "",
    sleep: "",
    dreams: "",
    perspiration: "",
    habits_addictions: "",
    thermal: "",
    craving: "",
    aversion: "",
    ailments_from: "",

    menstrual_history: "",

    weight: "",
    height: "",
    bp: "",
    pulse: "",
    temperature: "",

    cvs: "",
    rs: "",

    investigations: "",

    repertorial_totality: "",
  });

  const [mindData, setMindData] = useState({
    usual_mood: "",
    sensitivity_to_criticism: "",
    weeping_tendency: "",
    consolation: "",

    memory: "",
    concentration: "",
    mistakes: [], // checkbox group: speaking / writing / reading / calculating

    cleanliness: "",
    fastidious: "",
    disturbed_if_out_of_place: "",

    perfectionist: "",
    reaction_to_imperfection: "",
    high_expectations_self: "",
    high_expectations_others: "",

    follows_routine_strictly: "",
    adaptability_to_change: "",
    time_consciousness: "",
    lifestyle_discipline: "",

    working_style: "",
    multitasking: "",
    physical_energy: "",

    patience: "",
    reaction_while_waiting: "",

    stubbornness: "",
    changes_opinion_easily: "",

    forgives_or_holds_grudges: "",
    suppresses_or_expresses: "",
    overthinks_situations: "",

    nature: "",
    needs_control: "",

    social_type: "",
    comfort_with_strangers: "",
    adjusts_or_needs_space: "",

    responsibility: "",
    initiative_level: "",
    satisfaction: "",

    fears: [], // checkbox group
    specific_phobias: "",

    anxiety_about: [], // checkbox group
    anxiety_time: "",
    anticipatory_anxiety: "",

    anger_triggers: [], // checkbox group
    anger_expression: "",
    after_anger: "",

    past_emotional_shocks: "",
    effect_on_health: "",

    sleep_position: "",
    dream_themes: [], // checkbox group
    sleep_quality: "",

    ambition_level: "",
    religious_spiritual_tendency: "",
    artistic_creative_interests: "",
    peculiar_habits: "",
  });

  const [isClinicalOpen, setIsClinicalOpen] = useState(false);
  const [isSpeechOpen, setIsSpeechOpen] = useState(false);
  const [openMindSections, setOpenMindSections] = useState({});
  const [activeClinicalTab, setActiveClinicalTab] = useState("case_history");
  // After copying previous history, Mind first opens as a compact read-only
  // summary. Doctor can explicitly switch to Edit mode when changes are needed.
  const [isMindCopiedPreview, setIsMindCopiedPreview] = useState(false);
  const [isMindEditing, setIsMindEditing] = useState(false);

  const toggleMindSection = (key) => {
    setOpenMindSections((prev) => (prev[key] ? {} : { [key]: true }));
  };

  const fetchMedicineMaster = async () => {
    try {
      const response = await axios.get(`${Apiurl}/medicine_master`);
      setMedicineMaster(response.data || []);
    } catch (error) {
      console.log("Error fetching medicine master data:", error);
      setMedicineMaster([]);
    }
  };

  const fetchStockPharmacy = async () => {
    try {
      const response = await axios.get(`${Apiurl}/stock_pharmacy`);
      setStockPharmacy(response.data || []);
    } catch (error) {
      console.error("Error fetching stock pharmacy data:", error.message);
      setStockPharmacy([]);
    }
  };

  const fetchAppointment = async () => {
    try {
      const response = await axios.get(`${Apiurl}/appointments/${id}`);
      console.log("response from Appointment", response);
      setAppointment(response.data || {});
    } catch (error) {
      console.error("Error fetching appointment:", error);
    }
  };

  const fetchPrescriptions = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${Apiurl}/prescriptions/appointment/${id}`,
      );
      setPrescriptions(response.data);
    } catch (error) {
      console.error("Error fetching prescriptions:", error);
      setPrescriptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPatientHistory = async () => {
    const patientId = appointments?.patients_details?.[0]?.patient_id;

    if (!patientId) {
      setPatientHistoryData([]);
      return;
    }

    setIsHistoryLoading(true);

    try {
      const response = await axios.get(
        `${Apiurl}/prescriptions/patient/${patientId}`,
      );

      const historyList = Array.isArray(response.data) ? response.data : [];

      // Never treat the currently opened appointment as previous history.
      // Previous records stay read-only; only copied values go into this visit.
      const previousVisits = historyList
        .filter(
          (history) =>
            String(history?.appointment?._id || "") !== String(id || ""),
        )
        .sort((a, b) => {
          const aDate =
            a?.appointment?.appointment_date || a?.date || "1970-01-01";
          const bDate =
            b?.appointment?.appointment_date || b?.date || "1970-01-01";

          if (aDate === bDate) {
            return String(b?._id || "").localeCompare(String(a?._id || ""));
          }

          return String(bDate).localeCompare(String(aDate));
        });

      setPatientHistoryData(previousVisits);
    } catch (error) {
      // No previous visit is normal for a first-time patient.
      if (error?.response?.status !== 404) {
        console.error("Error fetching patient history:", error);
      }
      setPatientHistoryData([]);
    } finally {
      setIsHistoryLoading(false);
    }
  };

  const fetchPrescriptionDocuments = async () => {
    try {
      const response = await axios.get(
        `${Apiurl}/prescription-documents/appointment/${id}`,
      );
      setPrescriptionDocuments(response.data || []);
      setDocumentError("");
    } catch (error) {
      console.error("Error fetching prescription documents:", error);
      setPrescriptionDocuments([]);
      setDocumentError(
        error?.response?.data?.message || "Unable to load uploaded documents",
      );
    }
  };

  const fetchSpeechToText = async () => {
    try {
      const response = await axios.get(
        `${Apiurl}/speech-to-text/appointment/${id}`,
      );

      const speechData = response.data || {};
      setFormData((prev) => ({
        ...prev,
        speech_language: speechData.language || "english",
        speech_transcript: speechData.transcript || "",
      }));
    } catch (error) {
      // 404 is normal for a new consultation that has no saved speech note yet.
      if (error?.response?.status !== 404) {
        console.error("Error fetching speech-to-text data:", error);
      }

      setFormData((prev) => ({
        ...prev,
        speech_language: "english",
        speech_transcript: "",
      }));
    }
  };

  const handleDocumentSelection = (e) => {
    const files = Array.from(e.target.files || []);
    setSelectedDocuments(files);
    setDocumentError("");
  };

  const handleDocumentUpload = async (e) => {
    e.preventDefault();

    if (!documentType.trim()) {
      setDocumentError("Please select or enter the document type");
      return;
    }

    if (selectedDocuments.length === 0) {
      setDocumentError("Please select at least one document");
      return;
    }

    const uploadData = new FormData();
    uploadData.append("appointment", id);
    uploadData.append("document_type", documentType.trim());
    uploadData.append(
      "uploaded_by",
      localStorage.getItem("user_name") ||
        localStorage.getItem("user_type") ||
        "system",
    );
    selectedDocuments.forEach((file) => uploadData.append("documents", file));

    setIsUploadingDocuments(true);
    setDocumentError("");

    try {
      await axios.post(`${Apiurl}/prescription-documents`, uploadData);
      setSelectedDocuments([]);
      setDocumentType("");

      const fileInput = document.getElementById("prescription-document-input");
      if (fileInput) fileInput.value = "";

      await fetchPrescriptionDocuments();
    } catch (error) {
      console.error("Document upload error:", error);
      setDocumentError(
        error?.response?.data?.message || "Document upload failed",
      );
    } finally {
      setIsUploadingDocuments(false);
    }
  };

  const handleDeleteDocument = async (documentId) => {
    const shouldDelete = window.confirm(
      "Are you sure you want to delete this document?",
    );
    if (!shouldDelete) return;

    try {
      await axios.delete(`${Apiurl}/prescription-documents/${documentId}`);
      await fetchPrescriptionDocuments();
    } catch (error) {
      console.error("Document delete error:", error);
      setDocumentError(
        error?.response?.data?.message || "Unable to delete document",
      );
    }
  };

  const getDocumentUrl = (filePath) => {
    const apiBase = Apiurl.replace(/\/api\/?$/, "");
    return `${apiBase}${filePath}`;
  };

  const formatFileSize = (bytes) => {
    const size = Number(bytes || 0);
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };

  useEffect(() => {
    fetchAppointment();
    fetchPrescriptions();
    fetchMedicineMaster();
    fetchStockPharmacy();
    fetchPrescriptionDocuments();
    fetchSpeechToText();
  }, [id]);

  // Prefill the quick vitals fields (Weight, BP, Pulse, Temperature) at the
  // top of the prescription form, and the Physical Examination tab, using
  // the vitals captured on the Appointments page popup.
  useEffect(() => {
    const hasVitals =
      appointments?.weight ||
      appointments?.height ||
      appointments?.bp ||
      appointments?.pulse ||
      appointments?.temperature;

    if (!hasVitals) return;

    setFormData((prev) => ({
      ...prev,
      prescription_weight:
        prev.prescription_weight || appointments.weight || "",
      prescription_bp: prev.prescription_bp || appointments.bp || "",
      prescription_pulse: prev.prescription_pulse || appointments.pulse || "",
      prescription_temperature:
        prev.prescription_temperature || appointments.temperature || "",
    }));

    setDiagnosisData((prev) => ({
      ...prev,
      weight: prev.weight || appointments.weight || "",
      height: prev.height || appointments.height || "",
      bp: prev.bp || appointments.bp || "",
      pulse: prev.pulse || appointments.pulse || "",
      temperature: prev.temperature || appointments.temperature || "",
    }));
  }, [appointments]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (appointments?.patients_details?.[0]?.patient_id) {
      fetchPatientHistory();
    } else {
      setPatientHistoryData([]);
    }
  }, [appointments, id]);

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDiagnosisChange = (e) => {
    const { name, value } = e.target;
    setDiagnosisData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMindChange = (e) => {
    const { name, value } = e.target;
    setMindData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMindCheckboxChange = (fieldName, optionValue) => {
    setMindData((prev) => {
      const current = prev[fieldName] || [];
      const updated = current.includes(optionValue)
        ? current.filter((v) => v !== optionValue)
        : [...current, optionValue];
      return { ...prev, [fieldName]: updated };
    });
  };

  const medicineAddSubmit = async () => {
    try {
      const response = await axios.post(`${Apiurl}/medicine_master`, addData);
      setAddData(response.data);
      setShowAddModal(false);
      fetchMedicineMaster();
    } catch (error) {
      console.log("medicineAddSubmit error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleMedicineSearch = (e) => {
    setMedicineSearch(e.target.value);
    setFormData((prev) => ({
      ...prev,
      medicine_name: e.target.value,
      available_qty: 0,
      ...(isManualMedicineEntry ? {} : { price: "" }),
    }));
  };

  const handleMedicineFocus = () => {
    if (!isManualMedicineEntry) setShowMedicineDropdown(true);
  };
  const handleMedicineBlur = () => {
    setTimeout(() => setShowMedicineDropdown(false), 200);
  };

  const toggleManualMedicineEntry = () => {
    setIsManualMedicineEntry((prev) => {
      const next = !prev;
      if (next) {
        // Switching to manual entry: clear any selected/searched medicine
        // and let the user type a free-text medicine name and quantity.
        setShowMedicineDropdown(false);
        setMedicineSearch("");
        setFormData((formPrev) => ({
          ...formPrev,
          medicine_name: "",
          available_qty: 0,
          price: "",
        }));
      } else {
        // Switching back to search mode.
        setMedicineSearch("");
        setFormData((formPrev) => ({
          ...formPrev,
          medicine_name: "",
          available_qty: 0,
          price: "",
        }));
      }
      return next;
    });
  };

  const filteredMedicines = medicineMaster
    .filter((item) => {
      const medicineName = item.medicine_name || "";

      return medicineName.toLowerCase().includes(medicineSearch.toLowerCase());
    })
    .map((item) => {
      const stock = stockPharmacy.filter(
        (s) => String(s.medicine_id) === String(item._id),
      );

      const balance_quantity = stock.reduce(
        (sum, s) => sum + Number(s.balance_quantity || 0),
        0,
      );

      return {
        source: "medicine_master",
        medicine_name: item.medicine_name,
        unit: item.unit || "N/A",
        balance_quantity,
        _id: item._id,
      };
    });

  // ===== Previous Visit History: search + pagination =====
  const filteredHistoryData = patientHistoryData.filter((history) => {
    const query = historySearchQuery.trim().toLowerCase();
    if (!query) return true;

    const visitDate = String(
      history?.appointment?.appointment_date || history.date || "",
    ).toLowerCase();
    const appointmentId = String(
      history?.appointment?.appointment_id || "",
    ).toLowerCase();
    const doctorName = String(
      history?.appointment?.doctor?.doctor_name || "",
    ).toLowerCase();
    const complaint = String(
      history?.clinical_assessment?.presenting_complaints ||
        history?.diagnosis ||
        "",
    ).toLowerCase();
    const medicineNames = (history.medicines || [])
      .map((medicine) => (medicine.medicine_name || "").toLowerCase())
      .join(" ");

    return (
      visitDate.includes(query) ||
      appointmentId.includes(query) ||
      doctorName.includes(query) ||
      complaint.includes(query) ||
      medicineNames.includes(query)
    );
  });

  const historyTotalPages =
    historyPageSize === "all"
      ? 1
      : Math.max(1, Math.ceil(filteredHistoryData.length / historyPageSize));

  const paginatedHistoryData =
    historyPageSize === "all"
      ? filteredHistoryData
      : filteredHistoryData.slice(
          (historyCurrentPage - 1) * historyPageSize,
          historyCurrentPage * historyPageSize,
        );

  const handleHistorySearchChange = (e) => {
    setHistorySearchQuery(e.target.value);
    setHistoryCurrentPage(1);
  };

  const handleHistoryPageSizeChange = (e) => {
    const value = e.target.value;
    setHistoryPageSize(value === "all" ? "all" : Number(value));
    setHistoryCurrentPage(1);
  };

  // ===== Previous Visit History: "already provided?" medicine check =====
  // Full medicine_master list, filtered by what the user types in the
  // history-badge search dropdown.
  const historyMedicineOptions = medicineMaster.filter((item) => {
    const medicineName = item.medicine_name || "";
    return medicineName
      .toLowerCase()
      .includes(medicineCheckQuery.toLowerCase());
  });

  // Given a medicine name, scan every previous visit in patientHistoryData
  // (already fetched) to see if it was ever prescribed to this patient.
  const checkMedicineInHistory = (medicineName) => {
    let match = null;

    for (const visit of patientHistoryData) {
      const found = (visit.medicines || []).find(
        (m) =>
          (m.medicine_name || "").trim().toLowerCase() ===
          medicineName.trim().toLowerCase(),
      );

      if (found) {
        match = {
          visitDate: visit?.appointment?.appointment_date || visit.date,
          doctor: visit?.appointment?.doctor?.doctor_name,
        };
        break; // most recent match wins, patientHistoryData is already sorted newest-first
      }
    }

    setMedicineCheckResult({
      name: medicineName,
      provided: Boolean(match),
      visitDate: match?.visitDate,
      doctor: match?.doctor,
    });
    setMedicineCheckQuery(medicineName);
  };

  const selectMedicine = (medicine) => {
    setFormData((prev) => ({
      ...prev,
      medicine_name: medicine.medicine_name,
      available_qty: medicine.balance_quantity,
      price: "",
    }));
    setMedicineSearch(medicine.medicine_name);
    setShowMedicineDropdown(false);
  };

  const handleTimingChange = (timingType, time, value) => {
    setFormData((prev) => ({
      ...prev,
      timing: {
        ...prev.timing,
        [timingType]: {
          ...prev.timing[timingType],
          [time]: value,
        },
      },
    }));
  };

  const handleAdministrationChange = (mode) => {
    setFormData((prev) => ({
      ...prev,
      direct: mode === "direct",
      water: mode === "water",
    }));
  };

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const calculateNextVisitDate = (interval) => {
    if (!interval) return "";

    const baseDate = new Date();
    baseDate.setHours(12, 0, 0, 0);

    if (interval.startsWith("days:")) {
      const days = Number(interval.split(":")[1]);
      baseDate.setDate(baseDate.getDate() + days);
      return formatLocalDate(baseDate);
    }

    if (interval.startsWith("months:")) {
      const months = Number(interval.split(":")[1]);
      const originalDay = baseDate.getDate();

      // Clamp end-of-month dates (e.g. Jan 31 + 1 month => Feb 28/29).
      baseDate.setDate(1);
      baseDate.setMonth(baseDate.getMonth() + months);
      const lastDay = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth() + 1,
        0,
      ).getDate();
      baseDate.setDate(Math.min(originalDay, lastDay));
      return formatLocalDate(baseDate);
    }

    return "";
  };

  const handleNextVisitIntervalChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      next_visit_interval: value,
      next_visit_date: calculateNextVisitDate(value),
    }));
  };

  const handleAddMedicine = (e) => {
    e.preventDefault();
    if (!formData.medicine_name) {
      alert("Please fill in all required fields");
      return;
    }

    setMedicineList([
      ...medicineList,
      {
        medicine_name: formData.medicine_name,
        price: Number(formData.price || 0),
        dosage: formData.dosage,
        duration: formData.duration,
        sos: formData.sos,
        direct: formData.direct,
        water: formData.water,
        dose_type: formData.dose_type,
        // Keep the existing nested dose_type structure for backward compatibility
        // with history, print and pharmacy screens.
        timing: {
          fn: { ...formData.timing.fn, dose_type: formData.dose_type },
          an: { ...formData.timing.an, dose_type: formData.dose_type },
          night: { ...formData.timing.night, dose_type: formData.dose_type },
        },
      },
    ]);

    setFormData((prev) => ({
      ...prev,
      medicine_name: "",
      available_qty: 0,
      price: "",
      dosage: "",
      duration: "",
      dose_type: "drops",
      sos: false,
      direct: true,
      water: false,
      timing: {
        fn: { before: "0", after: "0", dose_type: "drops" },
        an: { before: "0", after: "0", dose_type: "drops" },
        night: { before: "0", after: "0", dose_type: "drops" },
      },
    }));
    setMedicineSearch("");
  };

  const handleRemoveMedicine = (index) => {
    setMedicineList(medicineList.filter((_, i) => i !== index));
  };

  const saveSpeechToText = async (prescriptionId) => {
    const actor =
      localStorage.getItem("user_name") ||
      localStorage.getItem("username") ||
      localStorage.getItem("user_id") ||
      localStorage.getItem("user_type") ||
      "system";

    return axios.post(`${Apiurl}/speech-to-text`, {
      appointment: id,
      prescription: prescriptionId,
      language: formData.speech_language || "english",
      transcript: formData.speech_transcript || "",
      created_by: actor,
      updated_by: actor,
    });
  };

  const handleSubmitAll = async (e) => {
    e.preventDefault();

    if (isListening) {
      alert(
        "Please stop speech recognition before submitting the prescription.",
      );
      return;
    }

    setIsSubmitting(true);
    try {
      const prescriptionData = {
        appointment: id,
        date: new Date().toISOString().split("T")[0],
        instructions: formData.instruction,
        next_visit_date: formData.next_visit_date,
        next_visit_interval: formData.next_visit_interval,
        medicines: medicineList,
        prescription_weight: formData.prescription_weight,
        prescription_bp: formData.prescription_bp,
        prescription_pulse: formData.prescription_pulse,
        prescription_temperature: formData.prescription_temperature,

        // Store the complete current Clinical Assessment exactly as entered.
        clinical_assessment: {
          ...diagnosisData,
          mind: mindData,
        },
      };

      const prescriptionResponse = await axios.post(
        `${Apiurl}/prescriptions`,
        prescriptionData,
      );

      console.log("prescriptionResponse", prescriptionResponse);

      const createdPrescriptionId = prescriptionResponse?.data?._id;
      if (!createdPrescriptionId) {
        throw new Error(
          "Prescription created but prescription ID was not returned",
        );
      }

      let speechSaveFailed = false;
      try {
        await saveSpeechToText(createdPrescriptionId);
      } catch (speechError) {
        // The prescription is already safely created at this point. Do not throw
        // and create duplicate prescriptions on retry just because speech-note
        // persistence failed.
        speechSaveFailed = true;
        console.error("Speech-to-text save failed:", speechError);
      }

      alert(
        speechSaveFailed
          ? "Prescription submitted successfully, but the speech note could not be saved. Please check the speech-to-text backend route."
          : "Prescription submitted successfully! Appointment is now In Progress until pharmacy billing is completed.",
      );

      navigate(`/appointments/prescription-data/bill/${createdPrescriptionId}`);
    } catch (error) {
      console.error("Error submitting prescription:", error);
      alert("Error submitting prescription");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (prescriptionId) => {
    try {
      await axios.delete(`${Apiurl}/prescriptions/${prescriptionId}`);
      fetchPrescriptions();
    } catch (error) {
      console.error("Error deleting prescription:", error);
      alert("Error deleting prescription");
    }
  };

  // Renders a dose-type/time value in the FN/AN/Night columns.
  // New records store "drops" / "counts" (dose_type). Older records may
  // still have a legacy "HH:MM" time value, so both are handled here.
  const formatTimeTo12Hour = (value) => {
    if (!value || value === "0" || value === "0:00") return "-";
    if (value === "drops" || value === "counts") {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (!value.includes(":")) return value;
    const [hours, minutes] = value.split(":");
    const hoursNum = parseInt(hours, 10);
    if (Number.isNaN(hoursNum)) return value;
    const period = hoursNum >= 12 ? "PM" : "AM";
    const hours12 = hoursNum % 12 || 12;
    return `${hours12}:${minutes} ${period}`;
  };

  const isEmptyHistoryValue = (value) => {
    if (value === null || value === undefined || value === "") return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === "object") {
      return Object.values(value).every((item) => isEmptyHistoryValue(item));
    }
    return false;
  };

  const formatHistoryLabel = (key) =>
    String(key || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const formatHistoryValue = (value) => {
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(", ") : "N/A";
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (value && typeof value === "object") {
      return Object.entries(value)
        .filter(([, nestedValue]) => !isEmptyHistoryValue(nestedValue))
        .map(
          ([nestedKey, nestedValue]) =>
            `${formatHistoryLabel(nestedKey)}: ${formatHistoryValue(
              nestedValue,
            )}`,
        )
        .join(" | ");
    }

    return value === null || value === undefined || value === ""
      ? "N/A"
      : String(value);
  };

  const getHistoryClinicalEntries = (history) => {
    const assessment = history?.clinical_assessment || {};

    return Object.entries(assessment).filter(
      ([key, value]) => key !== "mind" && !isEmptyHistoryValue(value),
    );
  };

  const getHistoryMindEntries = (history) => {
    const mind = history?.clinical_assessment?.mind || {};

    return Object.entries(mind).filter(
      ([, value]) => !isEmptyHistoryValue(value),
    );
  };

  const getHistoryLegacyEntries = (history) => {
    const legacyFields = {
      chief_complaint: history?.chief_complaint,
      history_of_present_complaint: history?.history_of_present_complaint,
      past_history: history?.past_history,
      family_history: history?.family_history,
      personal_history: history?.personal_history,
      appetite: history?.appetite,
      thirst: history?.thirst,
      desires_aversions: history?.desires_aversions,
      thermal_reaction: history?.thermal_reaction,
      perspiration: history?.perspiration,
      sleep: history?.sleep,
      dreams: history?.dreams,
      bowel: history?.bowel,
      urine: history?.urine,
      menstrual_history: history?.menstrual_history,
      mental_generals: history?.mental_generals,
      miasm: history?.miasm,
      constitution: history?.constitution,
      totality_of_symptoms: history?.totality_of_symptoms,
      repertorial_notes: history?.repertorial_notes,
      remedy_name: history?.remedy_name,
      potency: history?.potency,
      repetition: history?.repetition,
      remedy_duration: history?.remedy_duration,
      diet_advice: history?.diet_advice,
      diagnosis: history?.diagnosis,
      plan_of_treatment: history?.plan_of_treatment,
      investigations_reports: history?.scan_findings,
    };

    return Object.entries(legacyFields).filter(
      ([, value]) => !isEmptyHistoryValue(value),
    );
  };

  const normalizePreviousMedicines = (medicines = []) =>
    medicines
      .filter((medicine) => medicine?.medicine_name)
      .map((medicine) => ({
        medicine_name: medicine.medicine_name || "",
        dosage: medicine.dosage || "",
        duration: medicine.duration || "",
        sos: medicine.sos || false,
        timing: {
          fn: {
            before: medicine?.timing?.fn?.before || "0",
            after: medicine?.timing?.fn?.after || "0",
            time: medicine?.timing?.fn?.time || "0:00",
          },
          an: {
            before: medicine?.timing?.an?.before || "0",
            after: medicine?.timing?.an?.after || "0",
            time: medicine?.timing?.an?.time || "0:00",
          },
          night: {
            before: medicine?.timing?.night?.before || "0",
            after: medicine?.timing?.night?.after || "0",
            time: medicine?.timing?.night?.time || "0:00",
          },
        },
      }));

  const handleViewHistory = (history = null) => {
    setSelectedHistory(history);
    setShowPopupModal(true);
  };

  const handleCopyCaseDetails = (history) => {
    if (!history) return;

    const assessment = history.clinical_assessment || {};
    const { mind = {}, ...clinicalAssessment } = assessment;

    // Fallback mapping keeps older prescriptions useful even if they were
    // saved before clinical_assessment was introduced.
    const legacyClinicalAssessment = {
      presenting_complaints: history.chief_complaint || "",
      past_history: history.past_history || "",
      family_history: history.family_history || "",
      appetite: history.appetite || "",
      thirst: history.thirst || "",
      bowel_habits: history.bowel || "",
      urination: history.urine || "",
      sleep: history.sleep || "",
      dreams: history.dreams || "",
      perspiration: history.perspiration || "",
      thermal: history.thermal_reaction || "",
      menstrual_history: history.menstrual_history || "",
      investigations: history.scan_findings || "",
      repertorial_totality:
        history.repertorial_notes || history.totality_of_symptoms || "",
    };

    setDiagnosisData((prev) => ({
      ...prev,
      ...legacyClinicalAssessment,
      ...clinicalAssessment,
    }));

    setMindData((prev) => ({
      ...prev,
      ...(mind || {}),
    }));

    // Copied Mind data is shown in compact preview mode first.
    // It remains part of the current prescription state and can be edited only
    // after the doctor clicks Edit in the Mind section.
    setIsMindCopiedPreview(true);
    setIsMindEditing(false);
    setOpenMindSections({});

    setFormData((prev) => ({
      ...prev,
      prescription_weight:
        history.prescription_weight || prev.prescription_weight,
      prescription_bp: history.prescription_bp || prev.prescription_bp,
      prescription_pulse: history.prescription_pulse || prev.prescription_pulse,
      prescription_temperature:
        history.prescription_temperature || prev.prescription_temperature,
    }));

    setIsClinicalOpen(true);

    alert(
      "Previous case details copied to this visit. You can edit any field before submitting.",
    );
  };

  const handleSaveMindEdit = () => {
    // Mind values are already stored in mindData through the controlled inputs.
    // Save here means finish editing and return to the compact review view.
    // The final database save still happens with Submit Prescription.
    setIsMindEditing(false);
    setOpenMindSections({});
  };

  const handleContinuePrescription = (history) => {
    if (!history) return;

    const medicinesToContinue = normalizePreviousMedicines(history.medicines);

    if (medicinesToContinue.length === 0) {
      alert("No medicines are available in this previous prescription.");
      return;
    }

    if (
      medicineList.length > 0 &&
      !window.confirm(
        "Current medicine list already has items. Replace it with the previous prescription?",
      )
    ) {
      return;
    }

    setMedicineList(medicinesToContinue);
    setFormData((prev) => ({
      ...prev,
      instruction: history.instructions || "",
      medicine_name: "",
      available_qty: 0,
      dosage: "",
      duration: "",
      timing: {
        fn: { before: "0", after: "0", time: "0:00" },
        an: { before: "0", after: "0", time: "0:00" },
        night: { before: "0", after: "0", time: "0:00" },
      },
    }));
    setMedicineSearch("");

    alert(
      "Previous medicines copied to this visit. Review dosage/duration and make changes before submitting.",
    );
  };

  useEffect(() => {
    const query = patientLookupQuery.trim();

    if (query.length < 2 || selectedLookupPatient) {
      setPatientLookupResults([]);
      setShowPatientLookupDropdown(false);
      setPatientLookupActiveIndex(-1);
      return;
    }

    const timer = setTimeout(async () => {
      setPatientLookupLoading(true);
      setPatientLookupError("");

      try {
        const response = await axios.get(
          `${Apiurl}/patient_details/autocomplete`,
          { params: { query, limit: 8 } },
        );

        const results = Array.isArray(response.data) ? response.data : [];
        setPatientLookupResults(results);
        setShowPatientLookupDropdown(true);
        setPatientLookupActiveIndex(results.length > 0 ? 0 : -1);
      } catch (error) {
        console.error("Patient autocomplete failed:", error);
        setPatientLookupResults([]);
        setShowPatientLookupDropdown(false);

        if (error?.response?.status !== 404) {
          setPatientLookupError(
            error?.response?.data?.message || "Unable to search patients.",
          );
        }
      } finally {
        setPatientLookupLoading(false);
      }
    }, 250);

    return () => clearTimeout(timer);
  }, [patientLookupQuery, selectedLookupPatient]);

  const selectLookupPatient = (patient) => {
    setSelectedLookupPatient(patient);
    setPatientLookupQuery(
      `${patient.patient_id || ""} - ${patient.first_name || ""} ${
        patient.last_name || ""
      }`.trim(),
    );
    setPatientLookupResults([]);
    setShowPatientLookupDropdown(false);
    setPatientLookupActiveIndex(-1);
    setPatientLookupError("");
  };

  const openSelectedPatientSummary = (patient = selectedLookupPatient) => {
    if (!patient?._id) {
      setPatientLookupError(
        "Select a patient from the search results before opening the summary.",
      );
      return;
    }

    navigate(`/patients/clinical-summary/${patient._id}`);
  };

  const handlePatientLookup = (e) => {
    e.preventDefault();

    if (selectedLookupPatient) {
      openSelectedPatientSummary();
      return;
    }

    const firstResult =
      patientLookupResults[patientLookupActiveIndex] || patientLookupResults[0];

    if (firstResult) {
      selectLookupPatient(firstResult);
      openSelectedPatientSummary(firstResult);
      return;
    }

    setPatientLookupError(
      "Type Patient ID, mobile number, or name and select a patient.",
    );
  };

  const handlePatientLookupKeyDown = (e) => {
    if (!showPatientLookupDropdown || patientLookupResults.length === 0) {
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setPatientLookupActiveIndex((prev) =>
        prev < patientLookupResults.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setPatientLookupActiveIndex((prev) =>
        prev > 0 ? prev - 1 : patientLookupResults.length - 1,
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      const patient =
        patientLookupResults[patientLookupActiveIndex] ||
        patientLookupResults[0];
      if (patient) {
        selectLookupPatient(patient);
        openSelectedPatientSummary(patient);
      }
    } else if (e.key === "Escape") {
      setShowPatientLookupDropdown(false);
    }
  };

  const clearPatientLookup = () => {
    setPatientLookupQuery("");
    setPatientLookupError("");
    setPatientLookupResults([]);
    setSelectedLookupPatient(null);
    setShowPatientLookupDropdown(false);
    setPatientLookupActiveIndex(-1);
  };

  const handleOpenModal = () => {
    handleViewHistory(null);
  };

  const closeAddModal = () => {
    setShowPopupModal(false);
    setSelectedHistory(null);
  };

  // ===================== code for speech to text ========================
  // Language configs
  const LANGUAGES = {
    tamil: { label: "Tamil", code: "ta-IN" },
    english: { label: "English", code: "en-US" },
    both: { label: "Both (Tamil + English)", code: "both" },
  };

  const selectedLang = formData.speech_language || "english";
  const transcript = formData.speech_transcript || "";
  const [isListening, setIsListening] = useState(false);
  const [interimText, setInterimText] = useState("");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const recognitionRef = useRef(null);
  const shouldKeepListeningRef = useRef(false);
  // For "both" mode we alternate the recognizer's language on each restart,
  // since the Web Speech API only supports one language per session and
  // cannot truly code-switch mid-utterance.
  const bothToggleRef = useRef(0);
  const selectedLangRef = useRef(selectedLang);

  useEffect(() => {
    selectedLangRef.current = selectedLang;
  }, [selectedLang]);

  const SpeechRecognition =
    typeof window !== "undefined"
      ? window.SpeechRecognition || window.webkitSpeechRecognition
      : null;

  const getActiveLangCode = () => {
    const choice = selectedLangRef.current;
    if (choice === "both") {
      // alternate ta-IN / en-US each time recognition (re)starts
      const code = bothToggleRef.current % 2 === 0 ? "ta-IN" : "en-US";
      bothToggleRef.current += 1;
      return code;
    }
    return LANGUAGES[choice].code;
  };

  const createRecognizer = useCallback(() => {
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = getActiveLangCode();

    recognition.onresult = (event) => {
      let finalChunk = "";
      let interimChunk = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        const text = result[0].transcript;
        if (result.isFinal) {
          finalChunk += text + " ";
        } else {
          interimChunk += text;
        }
      }

      if (finalChunk) {
        const finalText = finalChunk.trim();
        setFormData((prev) => ({
          ...prev,
          speech_transcript: prev.speech_transcript
            ? `${prev.speech_transcript} ${finalText}`.trim()
            : finalText,
        }));
      }
      setInterimText(interimChunk);
    };

    recognition.onerror = (event) => {
      if (event.error === "no-speech") return; // benign, keep going
      if (
        event.error === "not-allowed" ||
        event.error === "service-not-allowed"
      ) {
        setError(
          "Microphone access was denied. Please allow microphone permission.",
        );
        shouldKeepListeningRef.current = false;
        setIsListening(false);
      } else if (event.error !== "aborted") {
        setError(`Speech recognition error: ${event.error}`);
      }
    };

    recognition.onend = () => {
      setInterimText("");
      // Auto-restart to keep listening continuously (also how "both" mode
      // switches language between Tamil and English on each restart).
      if (shouldKeepListeningRef.current) {
        try {
          const next = createRecognizer();
          recognitionRef.current = next;
          next.start();
        } catch (e) {
          setIsListening(false);
        }
      } else {
        setIsListening(false);
      }
    };

    return recognition;
  }, [SpeechRecognition]);

  const startListening = () => {
    setError("");

    if (!SpeechRecognition) {
      setError(
        "Speech recognition is not supported in this browser. Please use Chrome or Edge on desktop/Android.",
      );
      return;
    }

    bothToggleRef.current = 0;
    shouldKeepListeningRef.current = true;

    try {
      const recognition = createRecognizer();
      recognitionRef.current = recognition;
      recognition.start();
      setIsListening(true);
    } catch (e) {
      setError("Could not start microphone. Please try again.");
      setIsListening(false);
    }
  };

  const stopListening = () => {
    shouldKeepListeningRef.current = false;
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setIsListening(false);
    setInterimText("");
  };

  const toggleListening = () => {
    if (isListening) {
      stopListening();
    } else {
      startListening();
    }
  };

  const handleLanguageChange = (langKey) => {
    selectedLangRef.current = langKey;
    setFormData((prev) => ({ ...prev, speech_language: langKey }));
    if (isListening) {
      // restart recognition with the newly selected language
      stopListening();
      setTimeout(() => startListening(), 250);
    }
  };

  const clearTranscript = () => {
    setFormData((prev) => ({ ...prev, speech_transcript: "" }));
    setInterimText("");
  };

  const copyTranscript = async () => {
    if (!transcript) return;
    try {
      await navigator.clipboard.writeText(transcript);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      setError("Could not copy text.");
    }
  };

  useEffect(() => {
    return () => {
      shouldKeepListeningRef.current = false;
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
    };
  }, []);
  // ===================== code for speech to text ========================

  // ===================== Patient Documents panel (reusable) ========================
  // Shared by the Clinical Assessment > Patient Documents tab AND the
  // standalone modal opened from the Previous Visit History header, so
  // documents can be uploaded/updated for the current appointment even
  // when the Clinical Assessment card is hidden for a returning patient.
  const renderPatientDocumentsPanel = () => (
    <div className="border rounded">
      <div
        className="px-3 py-2 border-bottom d-flex align-items-center justify-content-between"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <h6 className="mb-0 d-flex align-items-center gap-2">
          <FileText size={16} />
          Patient Documents
        </h6>
        <small>{prescriptionDocuments.length} file(s)</small>
      </div>

      <div className="p-3">
        <div>
          <div className="row g-2 align-items-end">
            <div className="col-12 col-lg-4">
              <label className="form-label small fw-semibold mb-1">
                Document Type <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                list="document-type-options"
                className="form-control form-control-sm"
                value={documentType}
                onChange={(e) => {
                  setDocumentType(e.target.value);
                  setDocumentError("");
                }}
                placeholder="Select or type, e.g. Blood Report"
              />
              <datalist id="document-type-options">
                <option value="Blood Report" />
                <option value="Urine Report" />
                <option value="Lab Report" />
                <option value="Scan / Imaging Report" />
                <option value="X-Ray Report" />
                <option value="ECG Report" />
                <option value="Previous Prescription" />
                <option value="Discharge Summary" />
                <option value="Other" />
              </datalist>
            </div>

            <div className="col-12 col-lg-5">
              <label className="form-label small fw-semibold mb-1">
                Upload Documents
              </label>
              <input
                id="prescription-document-input"
                type="file"
                className="form-control form-control-sm"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,.ppt,.pptx"
                onChange={handleDocumentSelection}
              />
            </div>

            <div className="col-12 col-lg-3">
              <button
                type="button"
                className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2"
                onClick={handleDocumentUpload}
                disabled={
                  isUploadingDocuments ||
                  selectedDocuments.length === 0 ||
                  !documentType.trim()
                }
              >
                <Upload size={15} />
                {isUploadingDocuments
                  ? "Uploading..."
                  : `Upload${selectedDocuments.length > 1 ? ` (${selectedDocuments.length})` : ""}`}
              </button>
            </div>
          </div>
        </div>

        {selectedDocuments.length > 0 && (
          <div className="small text-secondary mt-2">
            Selected:{" "}
            {selectedDocuments.map((file) => file.name).join(", ")}
          </div>
        )}

        {documentError && (
          <div className="alert alert-danger py-2 px-3 small mt-2 mb-0">
            {documentError}
          </div>
        )}

        <div className="table-responsive mt-3">
          <table className="table table-sm table-bordered align-middle mb-0">
            <thead>
              <tr>
                <th style={{ width: "55px" }} className="text-center">
                  S.No
                </th>
                <th>Document</th>
                <th style={{ width: "160px" }}>Type</th>
                <th style={{ width: "110px" }}>Size</th>
                <th style={{ width: "170px" }}>Uploaded</th>
                <th style={{ width: "180px" }} className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {prescriptionDocuments.length > 0 ? (
                prescriptionDocuments.map((documentItem, index) => {
                  const fileUrl = getDocumentUrl(documentItem.file_path);
                  return (
                    <tr key={documentItem._id}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <FileText
                            size={16}
                            className="text-secondary flex-shrink-0"
                          />
                          <span style={{ wordBreak: "break-word" }}>
                            {documentItem.original_name}
                          </span>
                        </div>
                      </td>
                      <td>
                        {documentItem.document_type ||
                          documentItem.type ||
                          "-"}
                      </td>
                      <td>{formatFileSize(documentItem.file_size)}</td>
                      <td>
                        {documentItem.uploaded_date
                          ? new Date(
                              documentItem.uploaded_date,
                            ).toLocaleString()
                          : "-"}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center gap-1">
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-outline-primary btn-sm"
                            title="View / Open"
                          >
                            <ExternalLink size={14} />
                          </a>
                          <a
                            href={`${Apiurl}/prescription-documents/${documentItem._id}/download`}
                            className="btn btn-outline-success btn-sm"
                            title="Download"
                          >
                            <Download size={14} />
                          </a>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            title="Delete"
                            onClick={() =>
                              handleDeleteDocument(documentItem._id)
                            }
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-secondary py-3">
                    No documents uploaded for this appointment
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
  // ===================== Patient Documents panel (reusable) ========================

  return (
    <>
      <div className="p-3">
        <div>
          <div className="card-body">
            <div className="card mb-2">
              <div
                className="card-header rounded d-flex flex-wrap align-items-center justify-content-between gap-2"
                style={{ backgroundColor: "#01AEBE", color: "white" }}
              >
                <h6 className="mb-0">Patient Details</h6>

                <form
                  className="d-flex align-items-center gap-2"
                  onSubmit={handlePatientLookup}
                  style={{ width: "min(100%, 480px)", position: "relative" }}
                  autoComplete="off"
                >
                  <div className="input-group input-group-sm">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Patient ID / Mobile / Name"
                      value={patientLookupQuery}
                      onChange={(e) => {
                        setPatientLookupQuery(e.target.value);
                        setSelectedLookupPatient(null);
                        setPatientLookupError("");
                      }}
                      onFocus={() => {
                        if (patientLookupResults.length > 0) {
                          setShowPatientLookupDropdown(true);
                        }
                      }}
                      onKeyDown={handlePatientLookupKeyDown}
                      aria-label="Search patient by Patient ID, mobile number, or name"
                    />
                    {patientLookupQuery && (
                      <button
                        type="button"
                        className="btn btn-light border"
                        onClick={clearPatientLookup}
                        title="Clear patient search"
                      >
                        <X size={14} />
                      </button>
                    )}
                    <button
                      type="submit"
                      className="btn btn-light border"
                      disabled={patientLookupLoading}
                      title="Open selected patient summary"
                    >
                      {patientLookupLoading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <Search size={15} />
                      )}
                    </button>
                  </div>

                  {showPatientLookupDropdown && (
                    <div
                      className="position-absolute bg-white border rounded shadow-sm w-100"
                      style={{
                        top: "calc(100% + 4px)",
                        left: 0,
                        zIndex: 1050,
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >
                      {patientLookupResults.length > 0 ? (
                        patientLookupResults.map((patient, index) => (
                          <button
                            key={patient._id}
                            type="button"
                            className={`w-100 border-0 border-bottom text-start px-3 py-2 ${
                              index === patientLookupActiveIndex
                                ? "bg-light"
                                : "bg-white"
                            }`}
                            onMouseDown={(e) => e.preventDefault()}
                            onMouseEnter={() =>
                              setPatientLookupActiveIndex(index)
                            }
                            onClick={() => selectLookupPatient(patient)}
                          >
                            <div className="d-flex justify-content-between gap-2">
                              <strong
                                className="small"
                                style={{ color: "#01AEBE" }}
                              >
                                {patient.first_name || "N/A"}{" "}
                                {patient.last_name || ""}
                              </strong>
                              <span className="badge bg-light text-dark border">
                                {patient.patient_id || "N/A"}
                              </span>
                            </div>
                            <div className="small text-secondary mt-1 d-flex flex-wrap gap-2">
                              <span>{patient.mobile_no || "No mobile"}</span>
                              {patient.patient_type && (
                                <>
                                  <span>•</span>
                                  <span>{patient.patient_type}</span>
                                </>
                              )}
                            </div>
                          </button>
                        ))
                      ) : (
                        <div className="px-3 py-3 small text-muted text-center">
                          No matching patient found.
                        </div>
                      )}
                    </div>
                  )}
                </form>
              </div>

              <div className="row mb-3 g-2 p-3 pb-0">
                <div className="col-12 col-md-4">
                  <div className="row">
                    <div className="col-5">
                      <span className="fw-semibold text-secondary">
                        Patient ID:
                      </span>
                    </div>
                    <div className="col-7">
                      <span className="fw-medium text-dark">
                        {appointments?.patients_details?.[0]?.patient_id ||
                          "N/A"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="row">
                    <div className="col-5">
                      <span className="fw-semibold text-secondary">
                        Patient:
                      </span>
                    </div>
                    <div className="col-7">
                      <span className="fw-medium text-dark">
                        {appointments?.patients_details?.[0]?.first_name ||
                          "N/A"}{" "}
                        {appointments?.patients_details?.[0]?.last_name || ""}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="row">
                    <div className="col-5">
                      <span className="fw-semibold text-secondary">
                        Purpose:
                      </span>
                    </div>
                    <div className="col-7">
                      <span className="fw-medium text-dark">
                        {appointments?.patients_details?.[0]?.purpose || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {patientLookupError && (
                <div className="px-3 pb-3">
                  <div className="alert alert-warning py-2 mb-0 small">
                    {patientLookupError}
                  </div>
                </div>
              )}
            </div>

            <div className="card mb-2">
              <div className="row pt-2 px-2">
                <div className="col-md-3 mt-1 mb-2 d-flex gap-2">
                  <label className="small fw-semibold">Weight:</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="prescription_weight"
                    value={formData.prescription_weight}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mt-1 mb-2 d-flex gap-2">
                  <label
                    className="small fw-semibold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    BP:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="prescription_bp"
                    value={formData.prescription_bp}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mt-1 mb-2 d-flex gap-2">
                  <label
                    className="small fw-semibold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Pulse:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="prescription_pulse"
                    value={formData.prescription_pulse}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mt-1 mb-2 d-flex gap-2">
                  <label
                    className="small fw-semibold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Temperature:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="prescription_temperature"
                    value={formData.prescription_temperature}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmitAll}>
              {!isHistoryLoading && patientHistoryData.length === 0 && (
              <div className="card mt-3">
                <div
                  className="card-header rounded d-flex align-items-center justify-content-between "
                  style={{
                    backgroundColor: "#E7F8FA",
                    color: "#018A97",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsClinicalOpen((prev) => !prev)}
                  role="button"
                  aria-expanded={isClinicalOpen}
                >
                  <div>
                    <h6 className="mb-1">Clinical Assessment</h6>
                    {/* <small style={{ opacity: 0.85 }}>
                      Fill the patient&apos;s clinical, mind and supporting
                      document details.
                    </small> */}
                  </div>
                  <span className="fw-bold fs-5">
                    {isClinicalOpen ? "−" : "+"}
                  </span>
                </div>

                {isClinicalOpen && (
                  <>
                    <div className="bg-white border-bottom">
                      <div
                        className="d-flex flex-nowrap overflow-auto"
                        style={{ scrollbarWidth: "thin" }}
                      >
                        {[
                          { key: "case_history", label: "Case History" },
                          {
                            key: "physical_general",
                            label: "Physical General",
                          },
                          { key: "mind", label: "Mind" },
                          {
                            key: "physical_examination",
                            label: "Physical Examination",
                          },
                          {
                            key: "systemic_examination",
                            label: "Systemic Examination",
                          },
                          {
                            key: "investigations",
                            label: "Investigations & Repertorial Totality",
                          },
                          { key: "documents", label: "Patient Documents" },
                        ].map((tab) => (
                          <button
                            key={tab.key}
                            type="button"
                            className={`btn rounded-0 border-0 px-3 py-2 fw-semibold ${activeClinicalTab === tab.key ? "text-white" : "text-secondary"}`}
                            style={{
                              whiteSpace: "nowrap",
                              backgroundColor:
                                activeClinicalTab === tab.key
                                  ? "#01AEBE"
                                  : "transparent",
                              borderBottom:
                                activeClinicalTab === tab.key
                                  ? "3px solid #00a7b5"
                                  : "3px solid transparent",
                            }}
                            onClick={() => setActiveClinicalTab(tab.key)}
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="p-2">
                      {activeClinicalTab === "case_history" && (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold">Case History</h6>
                            <span className="badge bg-light text-secondary border">
                              1 / 7
                            </span>
                          </div>
                          <div className="row g-3 p-2">
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Presenting Complaints
                              </label>
                              <textarea
                                rows={3}
                                name="presenting_complaints"
                                className="form-control"
                                placeholder="Enter presenting complaints"
                                value={diagnosisData.presenting_complaints}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Past History
                              </label>
                              <textarea
                                rows={3}
                                name="past_history"
                                className="form-control"
                                placeholder="Enter past history"
                                value={diagnosisData.past_history}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Treatment History
                              </label>
                              <textarea
                                rows={3}
                                name="treatment_history"
                                className="form-control"
                                placeholder="Enter treatment history"
                                value={diagnosisData.treatment_history}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Family History
                              </label>
                              <textarea
                                rows={3}
                                name="family_history"
                                className="form-control"
                                placeholder="Enter family history"
                                value={diagnosisData.family_history}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {activeClinicalTab === "physical_general" && (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold">Physical General</h6>
                            <span className="badge bg-light text-secondary border">
                              2 / 7
                            </span>
                          </div>
                          <div className="row g-3 p-2">
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Diet
                              </label>
                              <input
                                type="text"
                                name="diet"
                                className="form-control"
                                placeholder="Enter diet"
                                value={diagnosisData.diet}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Appetite
                              </label>
                              <input
                                type="text"
                                name="appetite"
                                className="form-control"
                                placeholder="Enter appetite"
                                value={diagnosisData.appetite}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Thirst
                              </label>
                              <input
                                type="text"
                                name="thirst"
                                className="form-control"
                                placeholder="Enter thirst"
                                value={diagnosisData.thirst}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Bowel Habits
                              </label>
                              <input
                                type="text"
                                name="bowel_habits"
                                className="form-control"
                                placeholder="Enter bowel habits"
                                value={diagnosisData.bowel_habits}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Urination
                              </label>
                              <input
                                type="text"
                                name="urination"
                                className="form-control"
                                placeholder="Enter urination details"
                                value={diagnosisData.urination}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Sleep
                              </label>
                              <input
                                type="text"
                                name="sleep"
                                className="form-control"
                                placeholder="Enter sleep pattern"
                                value={diagnosisData.sleep}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Dreams
                              </label>
                              <input
                                type="text"
                                name="dreams"
                                className="form-control"
                                placeholder="Enter dreams"
                                value={diagnosisData.dreams}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Perspiration
                              </label>
                              <input
                                type="text"
                                name="perspiration"
                                className="form-control"
                                placeholder="Site, odor"
                                value={diagnosisData.perspiration}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Habits / Addictions
                              </label>
                              <input
                                type="text"
                                name="habits_addictions"
                                className="form-control"
                                placeholder="Enter habits / addictions"
                                value={diagnosisData.habits_addictions}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Thermal
                              </label>
                              <input
                                type="text"
                                name="thermal"
                                className="form-control"
                                placeholder="Chilly / Hot patient"
                                value={diagnosisData.thermal}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Craving
                              </label>
                              <input
                                type="text"
                                name="craving"
                                className="form-control"
                                placeholder="Enter craving"
                                value={diagnosisData.craving}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Aversion
                              </label>
                              <input
                                type="text"
                                name="aversion"
                                className="form-control"
                                placeholder="Enter aversion"
                                value={diagnosisData.aversion}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Ailments From
                              </label>
                              <input
                                type="text"
                                name="ailments_from"
                                className="form-control"
                                placeholder="Enter ailments from"
                                value={diagnosisData.ailments_from}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-3">
                              <label className="form-label fw-semibold">
                                Menstrual History
                              </label>
                              <input
                                type="text"
                                name="menstrual_history"
                                className="form-control"
                                placeholder="For female patients"
                                value={diagnosisData.menstrual_history}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {activeClinicalTab === "physical_examination" && (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold">
                              Physical Examination
                            </h6>
                            <span className="badge bg-light text-secondary border">
                              4 / 7
                            </span>
                          </div>
                          <div className="overflow-auto">
                            <div
                              className="row g-3 p-2 flex-nowrap"
                              style={{ minWidth: "700px" }}
                            >
                              <div className="col">
                                <label className="form-label fw-semibold">
                                  Weight
                                </label>
                                <input
                                  type="text"
                                  name="weight"
                                  className="form-control"
                                  placeholder="Enter weight"
                                  value={diagnosisData.weight}
                                  onChange={handleDiagnosisChange}
                                />
                              </div>
                              <div className="col">
                                <label className="form-label fw-semibold">
                                  Height
                                </label>
                                <input
                                  type="text"
                                  name="height"
                                  className="form-control"
                                  placeholder="Enter height"
                                  value={diagnosisData.height}
                                  onChange={handleDiagnosisChange}
                                />
                              </div>
                              <div className="col">
                                <label className="form-label fw-semibold">
                                  BP
                                </label>
                                <input
                                  type="text"
                                  name="bp"
                                  className="form-control"
                                  placeholder="Enter BP"
                                  value={diagnosisData.bp}
                                  onChange={handleDiagnosisChange}
                                />
                              </div>
                              <div className="col">
                                <label className="form-label fw-semibold">
                                  Pulse
                                </label>
                                <input
                                  type="text"
                                  name="pulse"
                                  className="form-control"
                                  placeholder="Enter pulse"
                                  value={diagnosisData.pulse}
                                  onChange={handleDiagnosisChange}
                                />
                              </div>
                              <div className="col">
                                <label className="form-label fw-semibold">
                                  Temperature
                                </label>
                                <input
                                  type="text"
                                  name="temperature"
                                  className="form-control"
                                  placeholder="Enter temperature"
                                  value={diagnosisData.temperature}
                                  onChange={handleDiagnosisChange}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {activeClinicalTab === "systemic_examination" && (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold">
                              Systemic Examination
                            </h6>
                            <span className="badge bg-light text-secondary border">
                              5 / 7
                            </span>
                          </div>
                          <div className="row g-3 p-2">
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                CVS
                              </label>
                              <textarea
                                rows={3}
                                name="cvs"
                                className="form-control"
                                placeholder="Enter CVS findings"
                                value={diagnosisData.cvs}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                RS
                              </label>
                              <textarea
                                rows={3}
                                name="rs"
                                className="form-control"
                                placeholder="Enter RS findings"
                                value={diagnosisData.rs}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {activeClinicalTab === "investigations" && (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold">
                              Investigations &amp; Repertorial Totality
                            </h6>
                            <span className="badge bg-light text-secondary border">
                              6 / 7
                            </span>
                          </div>
                          <div className="row g-3 p-2">
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Investigations
                              </label>
                              <textarea
                                rows={3}
                                name="investigations"
                                className="form-control"
                                placeholder="Lab reports, imaging, other investigations"
                                value={diagnosisData.investigations}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label fw-semibold">
                                Repertorial Totality
                              </label>
                              <textarea
                                rows={3}
                                name="repertorial_totality"
                                className="form-control"
                                placeholder="Enter repertorial totality"
                                value={diagnosisData.repertorial_totality}
                                onChange={handleDiagnosisChange}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {activeClinicalTab === "mind" && (
                        <>
                          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                            <div>
                              <h6 className="mb-1 fw-bold">Mind</h6>
                              <small className="text-secondary">
                                {isMindCopiedPreview
                                  ? isMindEditing
                                    ? "Edit the copied mind assessment, then click Save."
                                    : "Copied previous mind assessment. Review it before editing."
                                  : "Fill the patient's mental and behavioural characteristics."}
                              </small>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                              {isMindCopiedPreview && (
                                <button
                                  type="button"
                                  className={`btn btn-sm ${
                                    isMindEditing
                                      ? "btn-success"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() => {
                                    if (isMindEditing) {
                                      handleSaveMindEdit();
                                    } else {
                                      setIsMindEditing(true);
                                    }
                                  }}
                                >
                                  {isMindEditing ? "Save" : "Edit"}
                                </button>
                              )}
                              <span className="badge bg-light text-secondary border">
                                3 / 7
                              </span>
                            </div>
                          </div>
                          {isMindCopiedPreview && !isMindEditing ? (
                            <div className="p-2">
                              <div className="border rounded bg-light p-2">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 border-bottom pb-2 mb-1">
                                  <div>
                                    <div className="fw-bold small">
                                      Mind Assessment
                                    </div>
                                    <div
                                      className="text-muted"
                                      style={{ fontSize: "12px" }}
                                    >
                                      Previous history copied into this visit.
                                    </div>
                                  </div>
                                  <span className="badge bg-white text-secondary border">
                                    Read only
                                  </span>
                                </div>

                                {Object.entries(mindData).filter(
                                  ([, value]) => !isEmptyHistoryValue(value),
                                ).length === 0 ? (
                                  <div className="text-muted small py-2">
                                    No mind assessment details were available in
                                    the copied visit.
                                  </div>
                                ) : (
                                  <div className="row g-0">
                                    {Object.entries(mindData)
                                      .filter(
                                        ([, value]) =>
                                          !isEmptyHistoryValue(value),
                                      )
                                      .map(([key, value]) => (
                                        <div
                                          className="col-12 col-md-6 px-2 py-1 border-bottom small"
                                          key={key}
                                        >
                                          <span className="fw-semibold text-secondary">
                                            {formatHistoryLabel(key)}:
                                          </span>{" "}
                                          <span
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >
                                            {formatHistoryValue(value)}
                                          </span>
                                        </div>
                                      ))}
                                  </div>
                                )}

                                <div
                                  className="text-muted mt-2"
                                  style={{ fontSize: "11px" }}
                                >
                                  Click Edit above only when you need to change
                                  these copied values. Final save happens with
                                  Submit Prescription.
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="p-2">
                              <div className="row g-2">
                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("mood")}
                                    >
                                      <span className="fw-semibold">
                                        Mood &amp; Temperament
                                      </span>
                                      <span>
                                        {openMindSections.mood ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.mood && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Usual Mood
                                          </label>
                                          <select
                                            name="usual_mood"
                                            className="form-select"
                                            value={mindData.usual_mood}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Cheerful">
                                              Cheerful
                                            </option>
                                            <option value="Sad">Sad</option>
                                            <option value="Irritable">
                                              Irritable
                                            </option>
                                            <option value="Anxious">
                                              Anxious
                                            </option>
                                            <option value="Angry">Angry</option>
                                            <option value="Calm">Calm</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Sensitivity to Criticism
                                          </label>
                                          <select
                                            name="sensitivity_to_criticism"
                                            className="form-select"
                                            value={
                                              mindData.sensitivity_to_criticism
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Weeping Tendency
                                          </label>
                                          <select
                                            name="weeping_tendency"
                                            className="form-select"
                                            value={mindData.weeping_tendency}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Easy">Easy</option>
                                            <option value="Difficult">
                                              Difficult
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Consolation
                                          </label>
                                          <select
                                            name="consolation"
                                            className="form-select"
                                            value={mindData.consolation}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Better">
                                              Better
                                            </option>
                                            <option value="Worse">Worse</option>
                                            <option value="Indifferent">
                                              Indifferent
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("memory")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Memory &amp; Intellect
                                      </span>
                                      <span>
                                        {openMindSections.memory ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.memory && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Memory
                                          </label>
                                          <select
                                            name="memory"
                                            className="form-select"
                                            value={mindData.memory}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Good">Good</option>
                                            <option value="Weak">Weak</option>
                                            <option value="Forgets Names">
                                              Forgets Names
                                            </option>
                                            <option value="Forgets Places">
                                              Forgets Places
                                            </option>
                                            <option value="Forgets Words">
                                              Forgets Words
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Concentration
                                          </label>
                                          <select
                                            name="concentration"
                                            className="form-select"
                                            value={mindData.concentration}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Good">Good</option>
                                            <option value="Poor">Poor</option>
                                            <option value="Easily Distracted">
                                              Easily Distracted
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold d-block">
                                            Mistakes
                                          </label>
                                          {[
                                            "Speaking",
                                            "Writing",
                                            "Reading",
                                            "Calculating",
                                          ].map((opt) => (
                                            <div
                                              className="form-check form-check-inline"
                                              key={opt}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`mistakes-${opt}`}
                                                checked={mindData.mistakes.includes(
                                                  opt,
                                                )}
                                                onChange={() =>
                                                  handleMindCheckboxChange(
                                                    "mistakes",
                                                    opt,
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label small"
                                                htmlFor={`mistakes-${opt}`}
                                              >
                                                {opt}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("cleanliness")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Cleanliness &amp; Orderliness
                                      </span>
                                      <span>
                                        {openMindSections.cleanliness
                                          ? "−"
                                          : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.cleanliness && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Cleanliness
                                          </label>
                                          <select
                                            name="cleanliness"
                                            className="form-select"
                                            value={mindData.cleanliness}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Very Clean">
                                              Very Clean
                                            </option>
                                            <option value="Moderately Clean">
                                              Moderately Clean
                                            </option>
                                            <option value="Not Particular">
                                              Not Particular
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Fastidious
                                          </label>
                                          <select
                                            name="fastidious"
                                            className="form-select"
                                            value={mindData.fastidious}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="Low">Low</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Disturbed if Things Out of Place
                                          </label>
                                          <select
                                            name="disturbed_if_out_of_place"
                                            className="form-select"
                                            value={
                                              mindData.disturbed_if_out_of_place
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("perfectionism")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Perfectionism
                                      </span>
                                      <span>
                                        {openMindSections.perfectionism
                                          ? "−"
                                          : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.perfectionism && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Perfectionist
                                          </label>
                                          <select
                                            name="perfectionist"
                                            className="form-select"
                                            value={mindData.perfectionist}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Strong">
                                              Strong
                                            </option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="None">None</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Reaction to Imperfection
                                          </label>
                                          <select
                                            name="reaction_to_imperfection"
                                            className="form-select"
                                            value={
                                              mindData.reaction_to_imperfection
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Irritated">
                                              Irritated
                                            </option>
                                            <option value="Anxious">
                                              Anxious
                                            </option>
                                            <option value="Repeats Work">
                                              Repeats Work
                                            </option>
                                            <option value="Indifferent">
                                              Indifferent
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            High Expectations From Self
                                          </label>
                                          <select
                                            name="high_expectations_self"
                                            className="form-select"
                                            value={
                                              mindData.high_expectations_self
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            High Expectations From Others
                                          </label>
                                          <select
                                            name="high_expectations_others"
                                            className="form-select"
                                            value={
                                              mindData.high_expectations_others
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("routine")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Routine &amp; Discipline
                                      </span>
                                      <span>
                                        {openMindSections.routine ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.routine && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Follows Routine Strictly
                                          </label>
                                          <select
                                            name="follows_routine_strictly"
                                            className="form-select"
                                            value={
                                              mindData.follows_routine_strictly
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Adaptability to Change
                                          </label>
                                          <select
                                            name="adaptability_to_change"
                                            className="form-select"
                                            value={
                                              mindData.adaptability_to_change
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Easy">Easy</option>
                                            <option value="Difficult">
                                              Difficult
                                            </option>
                                            <option value="Very Difficult">
                                              Very Difficult
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Time Consciousness
                                          </label>
                                          <select
                                            name="time_consciousness"
                                            className="form-select"
                                            value={mindData.time_consciousness}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Punctual">
                                              Punctual
                                            </option>
                                            <option value="Often Late">
                                              Often Late
                                            </option>
                                            <option value="Always Rushed">
                                              Always Rushed
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Lifestyle Discipline
                                          </label>
                                          <select
                                            name="lifestyle_discipline"
                                            className="form-select"
                                            value={
                                              mindData.lifestyle_discipline
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="Low">Low</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("speed")}
                                    >
                                      <span className="fw-semibold">
                                        Speed &amp; Activity Level
                                      </span>
                                      <span>
                                        {openMindSections.speed ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.speed && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Working Style
                                          </label>
                                          <select
                                            name="working_style"
                                            className="form-select"
                                            value={mindData.working_style}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Fast">Fast</option>
                                            <option value="Slow">Slow</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Multitasking
                                          </label>
                                          <select
                                            name="multitasking"
                                            className="form-select"
                                            value={mindData.multitasking}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Good">Good</option>
                                            <option value="Poor">Poor</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Physical Energy
                                          </label>
                                          <select
                                            name="physical_energy"
                                            className="form-select"
                                            value={mindData.physical_energy}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Low">Low</option>
                                            <option value="Fluctuating">
                                              Fluctuating
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("patience")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Patience vs Impatience
                                      </span>
                                      <span>
                                        {openMindSections.patience ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.patience && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Patience
                                          </label>
                                          <select
                                            name="patience"
                                            className="form-select"
                                            value={mindData.patience}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Low">Low</option>
                                            <option value="Very Low">
                                              Very Low
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Reaction While Waiting
                                          </label>
                                          <select
                                            name="reaction_while_waiting"
                                            className="form-select"
                                            value={
                                              mindData.reaction_while_waiting
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Calm">Calm</option>
                                            <option value="Restless">
                                              Restless
                                            </option>
                                            <option value="Angry">Angry</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("obstinacy")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Obstinacy
                                      </span>
                                      <span>
                                        {openMindSections.obstinacy ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.obstinacy && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Stubbornness
                                          </label>
                                          <select
                                            name="stubbornness"
                                            className="form-select"
                                            value={mindData.stubbornness}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="Low">Low</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Changes Opinion Easily
                                          </label>
                                          <select
                                            name="changes_opinion_easily"
                                            className="form-select"
                                            value={
                                              mindData.changes_opinion_easily
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("emotional")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Emotional Processing
                                      </span>
                                      <span>
                                        {openMindSections.emotional ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.emotional && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Forgives Easily / Holds Grudges
                                          </label>
                                          <select
                                            name="forgives_or_holds_grudges"
                                            className="form-select"
                                            value={
                                              mindData.forgives_or_holds_grudges
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Forgives Easily">
                                              Forgives Easily
                                            </option>
                                            <option value="Holds Grudges">
                                              Holds Grudges
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Suppresses / Expresses Emotions
                                          </label>
                                          <select
                                            name="suppresses_or_expresses"
                                            className="form-select"
                                            value={
                                              mindData.suppresses_or_expresses
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Suppresses">
                                              Suppresses
                                            </option>
                                            <option value="Expresses Freely">
                                              Expresses Freely
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Overthinks Situations
                                          </label>
                                          <select
                                            name="overthinks_situations"
                                            className="form-select"
                                            value={
                                              mindData.overthinks_situations
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("control")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Control &amp; Dominance
                                      </span>
                                      <span>
                                        {openMindSections.control ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.control && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Nature
                                          </label>
                                          <select
                                            name="nature"
                                            className="form-select"
                                            value={mindData.nature}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Dominant">
                                              Dominant
                                            </option>
                                            <option value="Submissive">
                                              Submissive
                                            </option>
                                            <option value="Balanced">
                                              Balanced
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Needs Control in Situations
                                          </label>
                                          <select
                                            name="needs_control"
                                            className="form-select"
                                            value={mindData.needs_control}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("social")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Social Behaviour
                                      </span>
                                      <span>
                                        {openMindSections.social ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.social && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Introvert / Extrovert / Selective
                                          </label>
                                          <select
                                            name="social_type"
                                            className="form-select"
                                            value={mindData.social_type}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Introvert">
                                              Introvert
                                            </option>
                                            <option value="Extrovert">
                                              Extrovert
                                            </option>
                                            <option value="Selective">
                                              Selective
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Comfort With Strangers
                                          </label>
                                          <select
                                            name="comfort_with_strangers"
                                            className="form-select"
                                            value={
                                              mindData.comfort_with_strangers
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Easy">Easy</option>
                                            <option value="Difficult">
                                              Difficult
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Adjusts Easily / Needs Personal
                                            Space
                                          </label>
                                          <select
                                            name="adjusts_or_needs_space"
                                            className="form-select"
                                            value={
                                              mindData.adjusts_or_needs_space
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Adjusts Easily">
                                              Adjusts Easily
                                            </option>
                                            <option value="Needs Personal Space">
                                              Needs Personal Space
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("work")}
                                    >
                                      <span className="fw-semibold">
                                        Work Behaviour
                                      </span>
                                      <span>
                                        {openMindSections.work ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.work && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Responsibility
                                          </label>
                                          <select
                                            name="responsibility"
                                            className="form-select"
                                            value={mindData.responsibility}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="Poor">Poor</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Initiative Level
                                          </label>
                                          <select
                                            name="initiative_level"
                                            className="form-select"
                                            value={mindData.initiative_level}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Takes Lead">
                                              Takes Lead
                                            </option>
                                            <option value="Needs Pushing">
                                              Needs Pushing
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Satisfaction
                                          </label>
                                          <select
                                            name="satisfaction"
                                            className="form-select"
                                            value={mindData.satisfaction}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Difficult to Satisfy">
                                              Difficult to Satisfy
                                            </option>
                                            <option value="Easily Satisfied">
                                              Easily Satisfied
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("fears")}
                                    >
                                      <span className="fw-semibold">
                                        Fears &amp; Phobias
                                      </span>
                                      <span>
                                        {openMindSections.fears ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.fears && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12">
                                          <label className="form-label small fw-semibold d-block">
                                            Fears
                                          </label>
                                          {[
                                            "Darkness",
                                            "Loneliness",
                                            "Diseases",
                                            "Death",
                                            "Accidents",
                                            "Future",
                                            "Crowds",
                                            "Animals",
                                            "Driving",
                                            "Heights",
                                          ].map((opt) => (
                                            <div
                                              className="form-check form-check-inline"
                                              key={opt}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`fears-${opt}`}
                                                checked={mindData.fears.includes(
                                                  opt,
                                                )}
                                                onChange={() =>
                                                  handleMindCheckboxChange(
                                                    "fears",
                                                    opt,
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label small"
                                                htmlFor={`fears-${opt}`}
                                              >
                                                {opt}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                        <div className="col-12">
                                          <label className="form-label small fw-semibold">
                                            Specific Phobias
                                          </label>
                                          <input
                                            type="text"
                                            name="specific_phobias"
                                            className="form-control"
                                            placeholder="Enter specific phobias"
                                            value={mindData.specific_phobias}
                                            onChange={handleMindChange}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("anxiety")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Anxiety &amp; Worries
                                      </span>
                                      <span>
                                        {openMindSections.anxiety ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.anxiety && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold d-block">
                                            Anxiety About
                                          </label>
                                          {[
                                            "Health",
                                            "Family",
                                            "Future",
                                            "Money",
                                            "Work",
                                          ].map((opt) => (
                                            <div
                                              className="form-check form-check-inline"
                                              key={opt}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`anxiety-${opt}`}
                                                checked={mindData.anxiety_about.includes(
                                                  opt,
                                                )}
                                                onChange={() =>
                                                  handleMindCheckboxChange(
                                                    "anxiety_about",
                                                    opt,
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label small"
                                                htmlFor={`anxiety-${opt}`}
                                              >
                                                {opt}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Anxiety Time
                                          </label>
                                          <select
                                            name="anxiety_time"
                                            className="form-select"
                                            value={mindData.anxiety_time}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Morning">
                                              Morning
                                            </option>
                                            <option value="Evening">
                                              Evening
                                            </option>
                                            <option value="Night">Night</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Anticipatory Anxiety
                                          </label>
                                          <select
                                            name="anticipatory_anxiety"
                                            className="form-select"
                                            value={
                                              mindData.anticipatory_anxiety
                                            }
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("anger")}
                                    >
                                      <span className="fw-semibold">
                                        Anger &amp; Irritability
                                      </span>
                                      <span>
                                        {openMindSections.anger ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.anger && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold d-block">
                                            Triggers
                                          </label>
                                          {[
                                            "Contradiction",
                                            "Interference",
                                            "Delays",
                                            "Injustice",
                                          ].map((opt) => (
                                            <div
                                              className="form-check form-check-inline"
                                              key={opt}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`anger-${opt}`}
                                                checked={mindData.anger_triggers.includes(
                                                  opt,
                                                )}
                                                onChange={() =>
                                                  handleMindCheckboxChange(
                                                    "anger_triggers",
                                                    opt,
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label small"
                                                htmlFor={`anger-${opt}`}
                                              >
                                                {opt}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Expression
                                          </label>
                                          <select
                                            name="anger_expression"
                                            className="form-select"
                                            value={mindData.anger_expression}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Silent">
                                              Silent
                                            </option>
                                            <option value="Shouting">
                                              Shouting
                                            </option>
                                            <option value="Violent">
                                              Violent
                                            </option>
                                            <option value="Suppressed">
                                              Suppressed
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            After Anger
                                          </label>
                                          <select
                                            name="after_anger"
                                            className="form-select"
                                            value={mindData.after_anger}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Regret">
                                              Regret
                                            </option>
                                            <option value="Calm">Calm</option>
                                            <option value="Prolonged Irritation">
                                              Prolonged Irritation
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("stress")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Stress &amp; Emotional Trauma
                                      </span>
                                      <span>
                                        {openMindSections.stress ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.stress && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Past Emotional Shocks /
                                            Disappointments / Griefs
                                          </label>
                                          <textarea
                                            name="past_emotional_shocks"
                                            className="form-control"
                                            rows="2"
                                            value={
                                              mindData.past_emotional_shocks
                                            }
                                            onChange={handleMindChange}
                                          ></textarea>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Effect on Health
                                          </label>
                                          <textarea
                                            name="effect_on_health"
                                            className="form-control"
                                            rows="2"
                                            value={mindData.effect_on_health}
                                            onChange={handleMindChange}
                                          ></textarea>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() =>
                                        toggleMindSection("sleepdreams")
                                      }
                                    >
                                      <span className="fw-semibold">
                                        Sleep &amp; Dreams
                                      </span>
                                      <span>
                                        {openMindSections.sleepdreams
                                          ? "−"
                                          : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.sleepdreams && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Sleep Position
                                          </label>
                                          <select
                                            name="sleep_position"
                                            className="form-select"
                                            value={mindData.sleep_position}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Back">Back</option>
                                            <option value="Side">Side</option>
                                            <option value="Prone">Prone</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold d-block">
                                            Dream Themes
                                          </label>
                                          {[
                                            "Falling",
                                            "Flying",
                                            "Exam",
                                            "Death",
                                            "Fear",
                                            "Daily Events",
                                            "Sexual",
                                            "Others",
                                          ].map((opt) => (
                                            <div
                                              className="form-check form-check-inline"
                                              key={opt}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`dream-${opt}`}
                                                checked={mindData.dream_themes.includes(
                                                  opt,
                                                )}
                                                onChange={() =>
                                                  handleMindCheckboxChange(
                                                    "dream_themes",
                                                    opt,
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label small"
                                                htmlFor={`dream-${opt}`}
                                              >
                                                {opt}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Sleep Quality
                                          </label>
                                          <select
                                            name="sleep_quality"
                                            className="form-select"
                                            value={mindData.sleep_quality}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="Refreshing">
                                              Refreshing
                                            </option>
                                            <option value="Not Refreshing">
                                              Not Refreshing
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="border rounded">
                                    <div
                                      className="d-flex justify-content-between align-items-center px-3 py-2"
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: "#F2FBFC",
                                      }}
                                      onClick={() => toggleMindSection("other")}
                                    >
                                      <span className="fw-semibold">
                                        Other Individual Traits
                                      </span>
                                      <span>
                                        {openMindSections.other ? "−" : "+"}
                                      </span>
                                    </div>
                                    {openMindSections.other && (
                                      <div className="row g-3 p-3">
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Ambition Level
                                          </label>
                                          <select
                                            name="ambition_level"
                                            className="form-select"
                                            value={mindData.ambition_level}
                                            onChange={handleMindChange}
                                          >
                                            <option value="">Select</option>
                                            <option value="High">High</option>
                                            <option value="Moderate">
                                              Moderate
                                            </option>
                                            <option value="Low">Low</option>
                                          </select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Religious / Spiritual Tendency
                                          </label>
                                          <input
                                            type="text"
                                            name="religious_spiritual_tendency"
                                            className="form-control"
                                            value={
                                              mindData.religious_spiritual_tendency
                                            }
                                            onChange={handleMindChange}
                                          />
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Artistic / Creative Interests
                                          </label>
                                          <input
                                            type="text"
                                            name="artistic_creative_interests"
                                            className="form-control"
                                            value={
                                              mindData.artistic_creative_interests
                                            }
                                            onChange={handleMindChange}
                                          />
                                        </div>
                                        <div className="col-12 col-md-6">
                                          <label className="form-label small fw-semibold">
                                            Peculiar Habits
                                          </label>
                                          <input
                                            type="text"
                                            name="peculiar_habits"
                                            className="form-control"
                                            placeholder="Nail biting, humming, skin picking, repetitive acts"
                                            value={mindData.peculiar_habits}
                                            onChange={handleMindChange}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {activeClinicalTab === "documents" &&
                        renderPatientDocumentsPanel()}
                    </div>
                  </>
                )}
              </div>
              )}

              <div className="card mt-3">
                <div
                  className="card-header rounded d-flex align-items-center justify-content-between gap-2"
                  style={{
                    backgroundColor: "#E7F8FA",
                    color: "#018A97",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsHistoryOpen((prev) => !prev)}
                  role="button"
                  aria-expanded={isHistoryOpen}
                >
                  <div>
                    <h6 className="mb-1">Previous Visit History</h6>
                    {/* <small style={{ opacity: 0.85 }}>
                      View, copy case details, or continue a previous prescription.
                    </small> */}
                  </div>

                  <div
                    className="d-flex align-items-center gap-2 position-relative"
                    onClick={(e) => e.stopPropagation()}
                  >

                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center p-1"
                      // style={{ width: "28px", height: "28px" }}
                      title="Update patient documents"
                      onClick={() => setShowDocumentsModal(true)}
                    >
                      <div className="d-flex">
                        <span className="me-2"><FileText size={14} /></span>
                        <span>Document</span>
                      </div>
                      

                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center p-1"
                      style={{ width: "28px", height: "28px" }}
                      title="Check if a medicine was already given"
                      onClick={() => {
                        setIsMedicineCheckOpen((prev) => !prev);
                        setIsHistoryOpen(true);
                      }}
                    >
                      <Search size={14} />
                    </button>
                    
                    {patientHistoryData.length > 0 && (
                      <span className="badge bg-light text-dark">
                        {patientHistoryData.length} Visit
                        {patientHistoryData.length > 1 ? "s" : ""}
                      </span>
                    )}

                    

                    {isMedicineCheckOpen && (
                      <div
                        className="card shadow position-absolute"
                        style={{
                          top: "calc(100% + 6px)",
                          right: 0,
                          width: "300px",
                          zIndex: 20,
                          color: "#212529",
                        }}
                      >
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center gap-1 mb-2">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Search medicine..."
                              value={medicineCheckQuery}
                              onChange={(e) => {
                                setMedicineCheckQuery(e.target.value);
                                setMedicineCheckResult(null);
                              }}
                              autoFocus
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              title="Close"
                              onClick={() => {
                                setIsMedicineCheckOpen(false);
                                setMedicineCheckQuery("");
                                setMedicineCheckResult(null);
                              }}
                            >
                              <X size={14} />
                            </button>
                          </div>

                          {medicineCheckResult ? (
                            <div
                              className={`p-2 rounded small ${
                                medicineCheckResult.provided
                                  ? "bg-success bg-opacity-10 text-success"
                                  : "bg-danger bg-opacity-10 text-danger"
                              }`}
                            >
                              <div className="fw-semibold">
                                {medicineCheckResult.name}
                              </div>
                              {medicineCheckResult.provided ? (
                                <>
                                  <div>✅ Yes — already provided</div>
                                  {(medicineCheckResult.visitDate ||
                                    medicineCheckResult.doctor) && (
                                    <div className="text-muted">
                                      {medicineCheckResult.visitDate &&
                                        `on ${medicineCheckResult.visitDate}`}
                                      {medicineCheckResult.doctor &&
                                        ` by Dr. ${medicineCheckResult.doctor}`}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div>❌ No — not provided before</div>
                              )}
                              <button
                                type="button"
                                className="btn btn-sm btn-link p-0 mt-1"
                                onClick={() => setMedicineCheckResult(null)}
                              >
                                Search again
                              </button>
                            </div>
                          ) : (
                            medicineCheckQuery.trim() !== "" && (
                              <div
                                className="list-group"
                                style={{ maxHeight: "180px", overflowY: "auto" }}
                              >
                                {historyMedicineOptions.length === 0 ? (
                                  <div className="text-muted small px-1">
                                    No matching medicine found.
                                  </div>
                                ) : (
                                  historyMedicineOptions.map((item) => (
                                    <button
                                      key={item._id}
                                      type="button"
                                      className="list-group-item list-group-item-action py-1 px-2 small"
                                      onClick={() =>
                                        checkMedicineInHistory(
                                          item.medicine_name,
                                        )
                                      }
                                    >
                                      {item.medicine_name}
                                    </button>
                                  ))
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    <span className="fw-bold fs-5">
                      {isHistoryOpen ? "−" : "+"}
                    </span>
                  </div>
                </div>

                {isHistoryOpen && (
                  <>
                    {/* {patientHistoryData.length > 0 && (
                      <div className="d-flex justify-content-end p-2 border-bottom bg-light">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-info"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenModal();
                          }}
                        >
                          All History ({patientHistoryData.length})
                        </button>
                      </div>
                    )} */}

                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 p-2 border-bottom bg-light">
                      <div style={{ maxWidth: "280px", width: "100%" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search by date, doctor, complaint, medicine..."
                          value={historySearchQuery}
                          onChange={handleHistorySearchChange}
                        />
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        <label
                          className="small fw-semibold mb-0"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Show:
                        </label>
                        <select
                          className="form-select form-select-sm"
                          style={{ width: "auto" }}
                          value={historyPageSize}
                          onChange={handleHistoryPageSizeChange}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                          <option value="all">All</option>
                        </select>
                      </div>
                    </div>

                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-sm table-hover align-middle mb-0">
                          <thead
                            style={{
                              backgroundColor: "#01AEBE",
                              color: "white",
                            }}
                          >
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "55px" }}
                              >
                                S.No
                              </th>
                              <th style={{ minWidth: "105px" }}>Visit Date</th>
                              <th style={{ minWidth: "125px" }}>
                                Appointment ID
                              </th>
                              <th style={{ minWidth: "130px" }}>Doctor</th>
                              <th style={{ minWidth: "180px" }}>Complaint</th>
                              <th style={{ minWidth: "180px" }}>Medicines</th>
                              <th
                                className="text-center"
                                style={{ minWidth: "190px" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {isHistoryLoading ? (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="text-center text-muted py-3"
                                >
                                  Loading previous visits...
                                </td>
                              </tr>
                            ) : patientHistoryData.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="text-center text-muted py-3"
                                >
                                  No previous prescription visit found for this
                                  patient.
                                </td>
                              </tr>
                            ) : filteredHistoryData.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="text-center text-muted py-3"
                                >
                                  No matching visit found.
                                </td>
                              </tr>
                            ) : (
                              paginatedHistoryData.map(
                                (history, sliceIndex) => {
                                  const index =
                                    historyPageSize === "all"
                                      ? sliceIndex
                                      : (historyCurrentPage - 1) *
                                          historyPageSize +
                                        sliceIndex;

                                  const medicineNames = (
                                    history.medicines || []
                                  )
                                    .map((medicine) => medicine.medicine_name)
                                    .filter(Boolean)
                                    .slice(0, 3);

                                  const presentingComplaint =
                                    history?.clinical_assessment
                                      ?.presenting_complaints ||
                                    history?.diagnosis ||
                                    "N/A";

                                  const visitDate =
                                    history?.appointment?.appointment_date ||
                                    history.date ||
                                    "N/A";

                                  return (
                                    <tr key={history._id || index}>
                                      <td className="text-center">
                                        {index + 1}
                                      </td>

                                      <td className="fw-semibold">
                                        {visitDate}
                                      </td>

                                      <td>
                                        {history?.appointment?.appointment_id ||
                                          "N/A"}
                                      </td>

                                      <td>
                                        {history?.appointment?.doctor
                                          ?.doctor_name || "N/A"}
                                      </td>

                                      <td>
                                        <div
                                          className="text-truncate"
                                          style={{ maxWidth: "220px" }}
                                          title={presentingComplaint}
                                        >
                                          {presentingComplaint}
                                        </div>
                                      </td>

                                      <td>
                                        <div
                                          className="text-truncate"
                                          style={{ maxWidth: "220px" }}
                                          title={medicineNames.join(", ")}
                                        >
                                          {medicineNames.length > 0
                                            ? medicineNames.join(", ")
                                            : "N/A"}
                                          {(history.medicines || []).length > 3
                                            ? ` +${history.medicines.length - 3}`
                                            : ""}
                                        </div>
                                      </td>

                                      <td className="text-center">
                                        <div className="d-inline-flex flex-nowrap gap-1">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary px-2 py-1"
                                            title="View Details"
                                            onClick={() =>
                                              handleViewHistory(history)
                                            }
                                          >
                                            View
                                          </button>

                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary px-2 py-1"
                                            title="Copy Case History"
                                            onClick={() =>
                                              handleCopyCaseDetails(history)
                                            }
                                          >
                                            Copy
                                          </button>

                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-success px-2 py-1"
                                            title="Continue Previous Prescription"
                                            onClick={() =>
                                              handleContinuePrescription(
                                                history,
                                              )
                                            }
                                          >
                                            Continue
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                },
                              )
                            )}
                          </tbody>
                        </table>
                      </div>

                      {historyPageSize !== "all" &&
                        filteredHistoryData.length > 0 && (
                          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 p-2 border-top">
                            <div className="small text-secondary">
                              Showing{" "}
                              {(historyCurrentPage - 1) * historyPageSize + 1}–
                              {Math.min(
                                historyCurrentPage * historyPageSize,
                                filteredHistoryData.length,
                              )}{" "}
                              of {filteredHistoryData.length}
                            </div>

                            <div className="d-flex align-items-center gap-1">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                disabled={historyCurrentPage === 1}
                                onClick={() =>
                                  setHistoryCurrentPage((prev) =>
                                    Math.max(1, prev - 1),
                                  )
                                }
                              >
                                Prev
                              </button>

                              <span className="small px-2">
                                Page {historyCurrentPage} of{" "}
                                {historyTotalPages}
                              </span>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                disabled={
                                  historyCurrentPage === historyTotalPages
                                }
                                onClick={() =>
                                  setHistoryCurrentPage((prev) =>
                                    Math.min(historyTotalPages, prev + 1),
                                  )
                                }
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        )}
                    </div>
                  </>
                )}
              </div>

              {/* ===================== Case Study ===================== */}
              <div className="card mt-2">
                <div className="card-body p-3">
                  <label
                    htmlFor="case_study"
                    className="form-label small fw-semibold mb-2"
                  >
                    Case Study
                  </label>
                  <textarea
                    id="case_study"
                    name="case_study"
                    className="form-control form-control-sm"
                    rows={5}
                    value={diagnosisData.case_study || ""}
                    onChange={handleDiagnosisChange}
                    placeholder="Enter case study..."
                    style={{
                      width: "100%",
                      minHeight: "80px",
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>

              <div className="mt-3">
                <div className="card p-2">
                  {/* Medicine entry section.
                      UI-only responsive layout:
                      - flex-wrap prevents overlap while browser zoom changes
                      - each section has a safe minimum width
                      - SOS is placed with Dose Type / Administration to the
                        right side of the FN / AN / NIGHT table
                  */}
                  <div
                    className="d-flex flex-wrap align-items-end gap-3"
                    style={{ width: "100%" }}
                  >
                    {/* ================= Medicine ================= */}
                    <div
                      style={{
                        flex: "1.6 1 240px",
                        minWidth: "200px",
                        marginBottom:"40px"
                      }}
                    >
                      <div className="row g-2 align-items-end">
                        <div
                          className={
                            isManualMedicineEntry
                              ? "col-12 col-sm-7"
                              : "col-10"
                          }
                        >
                          <label className="small fw-semibold">
                            Medicine*
                          </label>

                          <div className="position-relative">
                            {isManualMedicineEntry ? (
                              <textarea
                                className="form-control form-control-sm"
                                value={medicineSearch}
                                onChange={handleMedicineSearch}
                                placeholder="e.g. Arnica Montana - 2d + Gelsemium - 3d"
                                rows={2}
                                style={{
                                  resize: "vertical",
                                  width: "100%",
                                }}
                                autoComplete="off"
                              />
                            ) : (
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicineSearch}
                                onChange={handleMedicineSearch}
                                onFocus={handleMedicineFocus}
                                onBlur={handleMedicineBlur}
                                placeholder={
                                  isManualMedicineEntry
                                    ? "Type Medicine Name"
                                    : "Search Medicine"
                                }
                                autoComplete="off"
                              />
                            )}

                            {!isManualMedicineEntry && (
                              <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
                            )}

                            {!isManualMedicineEntry &&
                              showMedicineDropdown && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    zIndex: 1000,
                                    width: "100%",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    backgroundColor: "white",
                                    border: "1px solid #ddd",
                                    boxShadow:
                                      "0 2px 4px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  {filteredMedicines.length > 0 ? (
                                    filteredMedicines.map(
                                      (medicine, index) => (
                                        <div
                                          key={
                                            medicine._id || index
                                          }
                                          style={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            borderBottom:
                                              "1px solid #eee",
                                            backgroundColor:
                                              "#fff",
                                          }}
                                          onMouseDown={(e) => {
                                            e.preventDefault();
                                            selectMedicine(
                                              medicine,
                                            );
                                          }}
                                        >
                                          {medicine.medicine_name}

                                          <div
                                            style={{
                                              fontSize:
                                                "0.8rem",
                                              color: "#666",
                                            }}
                                          >
                                            Unit:{" "}
                                            {medicine.unit} | Avl:{" "}
                                            {
                                              medicine.balance_quantity
                                            }
                                          </div>
                                        </div>
                                      ),
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        padding: "8px",
                                        color: "#666",
                                        fontStyle:
                                          "italic",
                                      }}
                                    >
                                      No Matching Medicines Found
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>

                        {isManualMedicineEntry && (
                          <div className="col-12 col-sm-3">
                            <label className="small fw-semibold">
                              Price
                            </label>

                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              className="form-control form-control-sm"
                              name="price"
                              value={formData.price}
                              onChange={handleChange}
                              placeholder="₹ Price"
                            />
                          </div>
                        )}

                        <div
                          className={
                            isManualMedicineEntry
                              ? "col-12 col-sm-2 d-flex"
                              : "col-2 d-flex"
                          }
                        >
                          <button
                            className={`btn btn-sm w-100 ${
                              isManualMedicineEntry
                                ? "btn-secondary"
                                : "btn-success"
                            }`}
                            type="button"
                            title={
                              isManualMedicineEntry
                                ? "Switch to Medicine Search"
                                : "Add Medicine Manually"
                            }
                            onClick={
                              toggleManualMedicineEntry
                            }
                          >
                            {isManualMedicineEntry
                              ? "×"
                              : "+"}
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* =========== Duration / Instruction =========== */}
                    <div
                      style={{
                        flex: "1 1 160px",
                        minWidth: "150px",
                        marginBottom:"40px"
                      }}
                    >
                      <label
                        className="small fw-semibold d-block mb-1"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Duration/Instruction
                      </label>

                      <textarea
                        className="form-control form-control-sm"
                        name="duration"
                        value={formData.duration}
                        onChange={handleChange}
                        rows={2}
                        style={{
                          resize: "vertical",
                          width: "100%",
                        }}
                      />
                    </div>

                    {/* ===== FN / AN / NIGHT + right-side controls ===== */}
                    <div
                      style={{
                        flex: "2.2 1 380px",
                        minWidth: "300px",
                      }}
                    >
                      <div className="d-flex flex-wrap align-items-start gap-3">
                        {/* FN / AN / NIGHT table */}
                        <div
                          className="table-responsive"
                          style={{
                            flex: "1 1 220px",
                            minWidth: "200px",
                          }}
                        >
                          <table
                            className="table table-bordered text-center mb-0 small"
                            style={{
                              width: "100%",
                              minWidth: "200px",
                              tableLayout: "fixed",
                            }}
                          >
                            <thead>
                              <tr>
                                <th>FN</th>
                                <th>AN</th>
                                <th>NIGHT</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                {["fn", "an", "night"].map(
                                  (slot) => (
                                    <td
                                      key={slot}
                                      className="align-middle"
                                    >
                                      <div
                                        className="d-flex flex-wrap justify-content-center align-items-center"
                                        style={{
                                          columnGap: "10px",
                                          rowGap: "4px",
                                        }}
                                      >
                                        <label
                                          className="d-flex align-items-center mb-0"
                                          style={{
                                            gap: "4px",
                                            whiteSpace:
                                              "nowrap",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={
                                              formData
                                                .timing[
                                                slot
                                              ].before ===
                                              "1"
                                            }
                                            onChange={(
                                              e,
                                            ) =>
                                              handleTimingChange(
                                                slot,
                                                "before",
                                                e.target
                                                  .checked
                                                  ? "1"
                                                  : "0",
                                              )
                                            }
                                          />
                                          BF
                                        </label>

                                        <label
                                          className="d-flex align-items-center mb-0"
                                          style={{
                                            gap: "4px",
                                            whiteSpace:
                                              "nowrap",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={
                                              formData
                                                .timing[
                                                slot
                                              ].after ===
                                              "1"
                                            }
                                            onChange={(
                                              e,
                                            ) =>
                                              handleTimingChange(
                                                slot,
                                                "after",
                                                e.target
                                                  .checked
                                                  ? "1"
                                                  : "0",
                                              )
                                            }
                                          />
                                          AF
                                        </label>
                                      </div>
                                    </td>
                                  ),
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Right-side control panel */}
                        <div
                          style={{
                            flex: "0 1 150px",
                            minWidth: "140px",
                          }}
                        >
                          <div
                            className="d-flex align-items-end gap-2 mb-2"
                            style={{ width: "100%" }}
                          >
                            <div style={{ flex: "1 1 auto", minWidth: 0 }}>
                              <label
                                className="small fw-semibold d-block mb-1"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Intake Type
                              </label>

                              <select
                                className="form-select form-select-sm"
                                name="dose_type"
                                value={formData.dose_type}
                                onChange={handleChange}
                                style={{ width: "100%" }}
                              >
                                <option value="drops">Drops</option>
                                <option value="counts">Counts</option>
                              </select>
                            </div>

                            <div
                              className="form-check mb-1"
                              style={{ flex: "0 0 auto", whiteSpace: "nowrap" }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="sos-checkbox"
                                name="sos"
                                checked={formData.sos}
                                onChange={handleChange}
                              />

                              <label
                                className="form-check-label small fw-semibold"
                                htmlFor="sos-checkbox"
                              >
                                SOS
                              </label>
                            </div>
                          </div>

                          <div
                            className="d-flex flex-wrap align-items-center"
                            style={{
                              columnGap: "14px",
                              rowGap: "6px",
                            }}
                          >
                            <div className="form-check mb-0">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="direct-radio"
                                name="administration_mode"
                                checked={formData.direct}
                                onChange={() =>
                                  handleAdministrationChange(
                                    "direct",
                                  )
                                }
                              />

                              <label
                                className="form-check-label small fw-semibold"
                                htmlFor="direct-radio"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Direct
                              </label>
                            </div>

                            <div className="form-check mb-0">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="water-radio"
                                name="administration_mode"
                                checked={formData.water}
                                onChange={() =>
                                  handleAdministrationChange(
                                    "water",
                                  )
                                }
                              />

                              <label
                                className="form-check-label small fw-semibold"
                                htmlFor="water-radio"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                With Water
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ================= Actions ================= */}
                    <div
                      className="d-flex align-items-end gap-2"
                      style={{
                        flex: "0 0 auto",
                        marginBottom:"40px"
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center justify-content-center gap-1"
                        onClick={handleAddMedicine}
                        disabled={isSubmitting}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <Plus size={14} />
                        Add
                      </button>

                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleOpenModal}
                      >
                        <Info size={14} />
                      </button>
                    </div>
                  </div>

                  <div className="p-2">
                    {isLoading ? (
                      <div className="text-center py-2 small">
                        Loading prescriptions...
                      </div>
                    ) : (
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        <table className="table table-bordered table-sm table-hover small">
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 2,
                            }}
                          >
                            <tr
                              style={{
                                backgroundColor: "#01AEBE",
                                color: "white",
                              }}
                            >
                              <th rowSpan="2" className="align-middle text-center">S.No</th>
                              <th rowSpan="2" className="align-middle text-center">Medicine</th>
                              <th rowSpan="2" className="align-middle text-center">Price</th>
                              <th rowSpan="2" className="align-middle text-center">Duration</th>
                              <th rowSpan="2" className="align-middle text-center">SOS</th>
                              <th rowSpan="2" className="align-middle text-center">Intake Type</th>
                              <th colSpan="2" className="text-center">FN</th>
                              <th colSpan="2" className="text-center">AN</th>
                              <th colSpan="2" className="text-center">Night</th>
                              <th rowSpan="2" className="align-middle text-center">Action</th>
                            </tr>
                            <tr
                              style={{
                                backgroundColor: "#01AEBE",
                                color: "white",
                              }}
                            >
                              <th className="text-center">BF</th>
                              <th className="text-center">AF</th>
                              <th className="text-center">BF</th>
                              <th className="text-center">AF</th>
                              <th className="text-center">BF</th>
                              <th className="text-center">AF</th>
                            </tr>
                          </thead>

                          <tbody>
                            {medicineList.length > 0 || prescriptions.length > 0 ? (
                              [
                                ...medicineList.map((medicine, mIdx) => (
                                  <tr key={`local-${mIdx}`}>
                                    <td className="text-center">{mIdx + 1}</td>
                                    <td>{medicine.medicine_name}</td>
                                    <td className="text-center">
                                      {Number(medicine.price || 0) > 0
                                        ? `₹${Number(medicine.price).toFixed(2)}`
                                        : "-"}
                                    </td>
                                    <td>{medicine.duration || "-"}</td>
                                    <td className="text-center">{medicine.sos ? "✓" : ""}</td>
                                    <td className="text-center">
                                      {`${
                                        medicine.dose_type
                                          ? medicine.dose_type.charAt(0).toUpperCase() + medicine.dose_type.slice(1)
                                          : "Drops"
                                      } - ${medicine.water ? "With Water" : "Direct"}`}
                                    </td>

                                    <td className="text-center">
                                      {medicine?.timing?.fn?.before === "1" ? "✓" : ""}
                                    </td>
                                    <td className="text-center">
                                      {medicine?.timing?.fn?.after === "1" ? "✓" : ""}
                                    </td>
                                    <td className="text-center">
                                      {medicine?.timing?.an?.before === "1" ? "✓" : ""}
                                    </td>
                                    <td className="text-center">
                                      {medicine?.timing?.an?.after === "1" ? "✓" : ""}
                                    </td>
                                    <td className="text-center">
                                      {medicine?.timing?.night?.before === "1" ? "✓" : ""}
                                    </td>
                                    <td className="text-center">
                                      {medicine?.timing?.night?.after === "1" ? "✓" : ""}
                                    </td>

                                    <td className="text-center">
                                      <button
                                        className="btn btn-sm p-1 border-0"
                                        onClick={() => handleRemoveMedicine(mIdx)}
                                        style={{ backgroundColor: "transparent" }}
                                      >
                                        <Trash2 size={16} className="text-danger" />
                                      </button>
                                    </td>
                                  </tr>
                                )),

                                ...prescriptions.flatMap((prescription, pIdx) =>
                                  prescription.medicines.map((medicine, mIdx) => (
                                    <tr key={`${prescription._id}-${mIdx}`}>
                                      <td className="text-center">
                                        {medicineList.length +
                                          prescriptions
                                            .slice(0, pIdx)
                                            .reduce(
                                              (total, item) => total + (item.medicines?.length || 0),
                                              0,
                                            ) +
                                          mIdx +
                                          1}
                                      </td>
                                      <td>{medicine.medicine_name}</td>
                                      <td className="text-center">
                                        {Number(medicine.price || 0) > 0
                                          ? `₹${Number(medicine.price).toFixed(2)}`
                                          : "-"}
                                      </td>
                                      <td>{medicine.duration || "-"}</td>
                                      <td className="text-center">{medicine.sos ? "✓" : ""}</td>
                                      <td className="text-center">
                                        {`${(
                                          medicine.dose_type ||
                                          medicine?.timing?.fn?.dose_type ||
                                          "drops"
                                        )
                                          .charAt(0)
                                          .toUpperCase() +
                                          (
                                            medicine.dose_type ||
                                            medicine?.timing?.fn?.dose_type ||
                                            "drops"
                                          ).slice(1)} - ${
                                          medicine.water ? "With Water" : "Direct"
                                        }`}
                                      </td>

                                      <td className="text-center">
                                        {medicine?.timing?.fn?.before === "1" ? "✓" : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.fn?.after === "1" ? "✓" : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.an?.before === "1" ? "✓" : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.an?.after === "1" ? "✓" : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.night?.before === "1" ? "✓" : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.night?.after === "1" ? "✓" : ""}
                                      </td>

                                      <td className="text-center">
                                        <button
                                          className="btn btn-sm p-1 border-0"
                                          onClick={() => handleDelete(prescription._id)}
                                          style={{ backgroundColor: "transparent" }}
                                        >
                                          <Trash2 size={16} className="text-danger" />
                                        </button>
                                      </td>
                                    </tr>
                                  )),
                                ),
                              ]
                            ) : (
                              <tr>
                                <td colSpan="13" className="text-center py-2 small">
                                  No prescriptions found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              

              {/* ===================== Instruction / Next Visit ===================== */}
              <div className="card mt-2">
                <div className="row g-3 p-3 align-items-start">
                  <div className="col-12 col-md-8">
                    <label
                      htmlFor="instruction"
                      className="form-label small fw-semibold mb-1"
                    >
                      Instruction
                    </label>
                    <textarea
                      id="instruction"
                      className="form-control form-control-sm"
                      name="instruction"
                      rows={3}
                      value={formData.instruction}
                      onChange={handleChange}
                      placeholder="Enter prescription instructions"
                      style={{
                        resize: "vertical",
                        minHeight: "72px",
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-4">
                    <label
                      htmlFor="next_visit_interval"
                      className="form-label small fw-semibold mb-1"
                    >
                      Medicine Duration / Next Visit After
                    </label>
                    <select
                      id="next_visit_interval"
                      className="form-select form-select-sm mb-2"
                      value={formData.next_visit_interval}
                      onChange={handleNextVisitIntervalChange}
                    >
                      <option value="">Select Duration</option>
                        <option value="days:1">1 Day</option>
                        <option value="days:2">2 Days</option>
                        <option value="days:3">3 Days</option>
                        <option value="days:4">4 Days</option>
                        <option value="days:5">5 Days</option>
                        <option value="days:6">6 Days</option>
                        <option value="days:7">7 Days</option>
                        <option value="days:8">8 Days</option>
                        <option value="days:9">9 Days</option>
                        <option value="days:10">10 Days</option>
                        <option value="days:11">11 Days</option>
                        <option value="days:12">12 Days</option>
                        <option value="days:13">13 Days</option>
                        <option value="days:14">14 Days</option>
                        <option value="days:15">15 Days</option>
                        <option value="days:20">20 Days</option>
                      <option value="months:1">1 Month</option>
                        <option value="days:45">45 Days</option>
                      <option value="months:2">2 Months</option>
                      <option value="months:3">3 Months</option>
                      <option value="months:4">4 Months</option>
                      <option value="months:5">5 Months</option>
                      <option value="months:6">6 Months</option>
                    </select>

                    <label
                      htmlFor="next_visit_date"
                      className="form-label small fw-semibold mb-1"
                    >
                      Next Visit Date
                    </label>
                    <input
                      id="next_visit_date"
                      type="date"
                      className="form-control form-control-sm"
                      name="next_visit_date"
                      value={formData.next_visit_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* ===================== code for speech to text ======================== */}
              <div className="card mt-2">
                <div
                  className="card-header rounded d-flex align-items-center justify-content-between gap-2"
                  style={{
                    backgroundColor: "#E7F8FA",
                    color: "#018A97",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsSpeechOpen((prev) => !prev)}
                  role="button"
                  aria-expanded={isSpeechOpen}
                >
                  <div>
                    <h6 className="mb-1">Conversation</h6>
                    <small style={{ opacity: 0.85 }}>
                      Record and manage the patient consultation conversation.
                    </small>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    {transcript && (
                      <span className="badge bg-light text-dark">
                        Saved Note
                      </span>
                    )}
                    <span className="fw-bold fs-5">
                      {isSpeechOpen ? "−" : "+"}
                    </span>
                  </div>
                </div>

                {isSpeechOpen && (
                  <div className="card-body p-3">
                    <div className="d-flex flex-wrap align-items-end justify-content-between gap-2 mb-3">
                      <div>
                        <label className="form-label small fw-semibold mb-1">
                          Language
                        </label>

                        <div className="d-flex flex-wrap gap-2">
                          {Object.entries(LANGUAGES).map(([key, lang]) => (
                            <button
                              type="button"
                              key={key}
                              onClick={() => handleLanguageChange(key)}
                              className={`btn btn-sm ${
                                selectedLang === key
                                  ? "btn-primary"
                                  : "btn-outline-secondary"
                              }`}
                              style={
                                selectedLang === key
                                  ? {
                                      backgroundColor: "#01AEBE",
                                      borderColor: "#01AEBE",
                                    }
                                  : undefined
                              }
                            >
                              {lang.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Listening + Clear + Copy */}
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          onClick={toggleListening}
                          className={`btn btn-sm d-inline-flex align-items-center gap-2 ${
                            isListening ? "btn-danger" : "btn-outline-primary"
                          }`}
                          style={
                            !isListening
                              ? {
                                  color: "#01AEBE",
                                  borderColor: "#01AEBE",
                                }
                              : undefined
                          }
                        >
                          {isListening ? (
                            <MicOff size={17} />
                          ) : (
                            <Mic size={17} />
                          )}
                          {isListening ? "Stop Listening" : "Start Listening"}
                        </button>

                        <button
                          type="button"
                          onClick={clearTranscript}
                          disabled={!transcript}
                          className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                        >
                          <Trash2 size={15} />
                          Clear
                        </button>

                        <button
                          type="button"
                          onClick={copyTranscript}
                          disabled={!transcript}
                          className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                        >
                          {copied ? <Check size={15} /> : <Copy size={15} />}
                          {copied ? "Copied" : "Copy"}
                        </button>
                      </div>
                    </div>

                    {selectedLang === "both" && (
                      <div className="alert alert-warning py-2 px-3 mb-3 small d-flex align-items-start gap-2">
                        <AlertCircle size={16} className="mt-1 flex-shrink-0" />
                        <span>
                          Both mode alternates between Tamil and English when
                          the recognizer restarts. Pause briefly when switching
                          languages for better results.
                        </span>
                      </div>
                    )}

                    {isListening && (
                      <div
                        className="d-flex align-items-center gap-2 small fw-semibold mb-3"
                        style={{ color: "#01AEBE" }}
                      >
                        <span
                          className="spinner-grow spinner-grow-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Listening...
                      </div>
                    )}

                    {error && (
                      <div className="alert alert-danger py-2 px-3 mb-3 small d-flex align-items-start gap-2">
                        <AlertCircle size={16} className="mt-1 flex-shrink-0" />
                        <span>{error}</span>
                      </div>
                    )}

                    <div className="mb-2">
                      <label
                        htmlFor="speech_transcript"
                        className="form-label small fw-semibold mb-1"
                      >
                        Transcript
                      </label>
                      <textarea
                        id="speech_transcript"
                        name="speech_transcript"
                        value={formData.speech_transcript}
                        onChange={handleChange}
                        rows={5}
                        className="form-control form-control-sm"
                        placeholder="Your transcribed text will appear here. You can also edit it before submitting."
                        style={{
                          resize: "vertical",
                          minHeight: "120px",
                        }}
                      />

                      {interimText && (
                        <div className="small text-muted fst-italic mt-2">
                          Listening: {interimText}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* ===================== code for speech to text ======================== */}

              <div className="d-flex justify-content-center align-items-center mt-3">
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit Prescription"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div
          className={`modal fade ${showAddModal ? "show" : ""}`}
          style={{
            display: showAddModal ? "block" : "none",
            background: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="addMedicineModalLabel"
          aria-hidden={!showAddModal}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h6
                  className="modal-title text-dark"
                  id="addMedicineModalLabel"
                >
                  Add Medicine
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setShowAddModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    medicineAddSubmit();
                  }}
                >
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="medicine_name" className="form-label">
                          Medicine Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="medicine_name"
                          name="medicine_name"
                          placeholder="Enter Medicine Name"
                          value={addData.medicine_name}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="category" className="form-label">
                          Category
                        </label>
                        <select
                          className="form-control"
                          id="category"
                          name="category"
                          value={addData.category}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Category</option>
                          <option value="Antibiotic">Antibiotic</option>
                          <option value="Pain Reliever">Pain Reliever</option>
                          <option value="Antiseptic">Antiseptic</option>
                          <option value="Antihistamine">Antihistamine</option>
                          <option value="Anti-inflammatory">
                            Anti-inflammatory
                          </option>
                          <option value="Cardiac Care">Cardiac Care</option>
                          <option value="Digestive Aid">Digestive Aid</option>
                          <option value="Electrolytes">Electrolytes</option>
                          <option value="Vitamins & Supplements">
                            Vitamins & Supplements
                          </option>
                          <option value="Antipyretic">Antipyretic</option>
                          <option value="Cough & Cold">Cough & Cold</option>
                          <option value="Dermatological">Dermatological</option>
                          <option value="Neurological">Neurological</option>
                          <option value="Hormonal">Hormonal</option>
                          <option value="Respiratory Care">
                            Respiratory Care
                          </option>
                          <option value="Gastrointestinal">
                            Gastrointestinal
                          </option>
                          <option value="Yoga">Yoga</option>
                          <option value="Antifungal">Antifungal</option>
                          <option value="Antiviral">Antiviral</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="medicine_type" className="form-label">
                          Medicine Type
                        </label>
                        <select
                          className="form-control"
                          id="medicine_type"
                          name="medicine_type"
                          value={addData.medicine_type}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Type</option>
                          <option value="Tablet">Tablet</option>
                          <option value="Bottle">Bottle</option>
                          <option value="Capsule">Capsule</option>
                          <option value="Syrup">Syrup</option>
                          <option value="Injection">Injection</option>
                          <option value="Powder">Powder</option>
                          <option value="Sachet">Sachet</option>
                          <option value="Cream">Cream</option>
                          <option value="Ointment">Ointment</option>
                          <option value="Gel">Gel</option>
                          <option value="Drops">Drops</option>
                          <option value="Inhaler">Inhaler</option>
                          <option value="Suppository">Suppository</option>
                          <option value="Suspension">Suspension</option>
                          <option value="Spray">Spray</option>
                          <option value="Lotion">Lotion</option>
                          <option value="Solution">Solution</option>
                          <option value="Patch">Patch</option>
                          <option value="Dispersible Tablet">
                            Dispersible Tablet
                          </option>
                          <option value="Chewable Tablet">
                            Chewable Tablet
                          </option>
                          <option value="IV Fluid">IV Fluid</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="manufacturer" className="form-label">
                          Manufacturer
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="manufacturer"
                          name="manufacturer"
                          placeholder="Enter Manufacturer"
                          value={addData.manufacturer}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="hsn_code" className="form-label">
                          HSN Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="hsn_code"
                          name="hsn_code"
                          placeholder="Enter HSN Code"
                          value={addData.hsn_code}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="gst_percentage" className="form-label">
                          GST (%)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="gst_percentage"
                          name="gst_percentage"
                          placeholder="Enter GST (%)"
                          value={addData.gst_percentage}
                          onChange={handleAddInputChange}
                          required
                          min="0"
                          max="100"
                          step="0.01"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="unit" className="form-label">
                          Unit
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="unit"
                          name="unit"
                          placeholder="Enter Unit"
                          value={addData.unit}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={addData.status}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="notes" className="form-label">
                          Notes
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="notes"
                          name="notes"
                          placeholder="Enter Notes"
                          value={addData.notes}
                          onChange={handleAddInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${showPopupModal ? "show" : ""}`}
          style={{
            display: showPopupModal ? "block" : "none",
            background: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="patientHistoryModalLabel"
          aria-hidden={!showPopupModal}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
            style={{ maxWidth: "95vw" }}
          >
            <div className="modal-content" style={{ maxHeight: "92vh" }}>
              <div className="modal-header py-2">
                <h6
                  className="modal-title text-dark"
                  id="patientHistoryModalLabel"
                >
                  {selectedHistory
                    ? "Previous Visit Details"
                    : "Patient History"}{" "}
                  ({appointments?.patients_details?.[0]?.patient_id || "N/A"})
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeAddModal}
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body p-2">
                <div className="border rounded bg-light px-2 py-1 mb-2">
                  <div className="row g-1 small">
                    <div className="col-12 col-md-4">
                      <span className="fw-semibold">Patient ID:</span>{" "}
                      {appointments?.patients_details?.[0]?.patient_id || "N/A"}
                    </div>
                    <div className="col-12 col-md-4">
                      <span className="fw-semibold">Patient:</span>{" "}
                      {appointments?.patients_details?.[0]?.first_name || "N/A"}{" "}
                      {appointments?.patients_details?.[0]?.last_name || ""}
                    </div>
                    <div className="col-12 col-md-4">
                      <span className="fw-semibold">Age / Sex:</span>{" "}
                      {appointments?.patients_details?.[0]?.age || "N/A"} /{" "}
                      {appointments?.patients_details?.[0]?.gender || "N/A"}
                    </div>
                  </div>
                </div>

                {patientHistoryData.length === 0 ? (
                  <div className="alert alert-info py-2 mb-0 small">
                    No prescription history found for patient{" "}
                    {appointments?.patients_details?.[0]?.patient_id || "N/A"}
                  </div>
                ) : (
                  (selectedHistory
                    ? [selectedHistory]
                    : patientHistoryData
                  ).map((history, historyIndex) => (
                    <div
                      key={history._id || historyIndex}
                      className="border rounded mb-2"
                    >
                      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-2 py-2 border-bottom bg-light">
                        <div className="small fw-semibold">
                          Visit {historyIndex + 1}
                        </div>

                        <div className="d-flex flex-nowrap gap-1">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary py-0 px-2"
                            onClick={() => handleCopyCaseDetails(history)}
                            title="Copy Case Details"
                          >
                            Copy
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-success py-0 px-2"
                            onClick={() => handleContinuePrescription(history)}
                            title="Continue Previous Prescription"
                          >
                            Continue
                          </button>
                        </div>
                      </div>

                      <div className="p-2">
                        <div className="row g-1 small mb-2">
                          <div className="col-12 col-md-6">
                            <span className="fw-semibold">Date:</span>{" "}
                            {history.date ||
                              history?.appointment?.appointment_date ||
                              "N/A"}
                          </div>
                          <div className="col-12 col-md-6">
                            <span className="fw-semibold">Doctor:</span>{" "}
                            {history?.appointment?.doctor?.doctor_name || "N/A"}
                          </div>
                          <div className="col-12 col-md-6">
                            <span className="fw-semibold">Department:</span>{" "}
                            {history?.appointment?.department || "N/A"}
                          </div>
                          <div className="col-12 col-md-6">
                            <span className="fw-semibold">Next Visit:</span>{" "}
                            {history.next_visit_date || "N/A"}
                          </div>
                          <div className="col-12">
                            <span className="fw-semibold">Instructions:</span>{" "}
                            <span style={{ whiteSpace: "pre-wrap" }}>
                              {history.instructions || "N/A"}
                            </span>
                          </div>
                        </div>

                        <div className="border rounded px-2 py-1 mb-2">
                          <div className="row g-1 small">
                            <div className="col-6 col-md-3">
                              <span className="fw-semibold">Weight:</span>{" "}
                              {history.prescription_weight || "N/A"}
                            </div>
                            <div className="col-6 col-md-3">
                              <span className="fw-semibold">BP:</span>{" "}
                              {history.prescription_bp || "N/A"}
                            </div>
                            <div className="col-6 col-md-3">
                              <span className="fw-semibold">Pulse:</span>{" "}
                              {history.prescription_pulse || "N/A"}
                            </div>
                            <div className="col-6 col-md-3">
                              <span className="fw-semibold">Temperature:</span>{" "}
                              {history.prescription_temperature || "N/A"}
                            </div>
                          </div>
                        </div>

                        <div className="mb-2">
                          <div className="small fw-bold text-dark border-bottom pb-1 mb-1">
                            Clinical Assessment
                          </div>
                          {getHistoryClinicalEntries(history).length === 0 ? (
                            <div className="text-muted small">
                              No clinical assessment details were saved for this
                              visit.
                            </div>
                          ) : (
                            <div className="row g-0">
                              {getHistoryClinicalEntries(history).map(
                                ([key, value]) => (
                                  <div
                                    className="col-12 col-md-6 px-1 py-1 border-bottom small d-flex"
                                    key={key}
                                  >
                                    <span
                                      className="fw-semibold text-secondary flex-shrink-0"
                                      style={{ width: "45%" }}
                                    >
                                      {formatHistoryLabel(key)}:
                                    </span>
                                    <span
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        width: "55%",
                                      }}
                                    >
                                      {formatHistoryValue(value)}
                                    </span>
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        <div className="mb-2">
                          <div className="small fw-bold text-dark border-bottom pb-1 mb-1">
                            Mind Assessment
                          </div>
                          {getHistoryMindEntries(history).length === 0 ? (
                            <div className="text-muted small">
                              No mind assessment details were saved for this
                              visit.
                            </div>
                          ) : (
                            <div className="row g-0">
                              {getHistoryMindEntries(history).map(
                                ([key, value]) => (
                                  <div
                                    className="col-12 col-md-6 px-1 py-1 border-bottom small d-flex"
                                    key={key}
                                  >
                                    <span
                                      className="fw-semibold text-secondary flex-shrink-0"
                                      style={{ width: "45%" }}
                                    >
                                      {formatHistoryLabel(key)}:
                                    </span>
                                    <span
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        width: "55%",
                                      }}
                                    >
                                      {formatHistoryValue(value)}
                                    </span>
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        {getHistoryLegacyEntries(history).length > 0 && (
                          <div className="mb-2">
                            <div className="small fw-bold text-dark border-bottom pb-1 mb-1">
                              Other Saved / Legacy Details
                            </div>
                            <div className="row g-0">
                              {getHistoryLegacyEntries(history).map(
                                ([key, value]) => (
                                  <div
                                    className="col-12 col-md-6 px-1 py-1 border-bottom small"
                                    key={key}
                                  >
                                    <span className="fw-semibold text-secondary">
                                      {formatHistoryLabel(key)}:
                                    </span>{" "}
                                    <span style={{ whiteSpace: "pre-wrap" }}>
                                      {formatHistoryValue(value)}
                                    </span>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        )}

                        <div className="small fw-bold text-dark border-bottom pb-1 mb-1">
                          Medicines
                        </div>

                        <div className="table-responsive">
                          <table className="table table-sm table-bordered align-middle small mb-0">
                            <thead
                              style={{
                                backgroundColor: "#01AEBE",
                                color: "white",
                              }}
                            >
                              <tr>
                                <th
                                  rowSpan="2"
                                  className="align-middle text-center"
                                >
                                  S.No
                                </th>
                                <th
                                  rowSpan="2"
                                  className="align-middle text-center"
                                >
                                  Medicine
                                </th>
                                <th
                                  rowSpan="2"
                                  className="align-middle text-center"
                                >
                                  Dosage
                                </th>
                                <th
                                  rowSpan="2"
                                  className="align-middle text-center"
                                >
                                  Duration
                                </th>
                                <th
                                  rowSpan="2"
                                  className="align-middle text-center"
                                >
                                  SOS
                                </th>
                                <th colSpan="3" className="text-center">
                                  FN
                                </th>
                                <th colSpan="3" className="text-center">
                                  AN
                                </th>
                                <th colSpan="3" className="text-center">
                                  Night
                                </th>
                              </tr>
                              <tr
                                style={{
                                  backgroundColor: "#01AEBE",
                                  color: "white",
                                }}
                              >
                                <th className="text-center">Type</th>
                                <th className="text-center">B</th>
                                <th className="text-center">A</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">B</th>
                                <th className="text-center">A</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">B</th>
                                <th className="text-center">A</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(history.medicines || []).length > 0 ? (
                                (history.medicines || []).map(
                                  (medicine, mIdx) => (
                                    <tr key={`${history._id}-${mIdx}`}>
                                      <td className="text-center">
                                        {mIdx + 1}
                                      </td>
                                      <td>{medicine.medicine_name || "N/A"}</td>
                                      <td>{medicine.dosage || "N/A"}</td>
                                      <td>{medicine.duration || "N/A"}</td>
                                      <td className="text-center">
                                        {medicine.sos ? "✓" : ""}
                                      </td>

                                      <td className="text-center">
                                        {formatTimeTo12Hour(
                                          medicine?.timing?.fn?.dose_type || medicine?.timing?.fn?.time,
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.fn?.before === "1"
                                          ? "✓"
                                          : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.fn?.after === "1"
                                          ? "✓"
                                          : ""}
                                      </td>

                                      <td className="text-center">
                                        {formatTimeTo12Hour(
                                          medicine?.timing?.an?.dose_type || medicine?.timing?.an?.time,
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.an?.before === "1"
                                          ? "✓"
                                          : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.an?.after === "1"
                                          ? "✓"
                                          : ""}
                                      </td>

                                      <td className="text-center">
                                        {formatTimeTo12Hour(
                                          medicine?.timing?.night?.dose_type || medicine?.timing?.night?.time,
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.night?.before === "1"
                                          ? "✓"
                                          : ""}
                                      </td>
                                      <td className="text-center">
                                        {medicine?.timing?.night?.after === "1"
                                          ? "✓"
                                          : ""}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={13}
                                    className="text-center text-muted py-2"
                                  >
                                    No medicines saved for this visit.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ===================== Patient Documents Modal ===================== */}
        {/* Opened from the Previous Visit History header so documents can be
            uploaded/updated for the current appointment even when the
            Clinical Assessment card is hidden (returning patient). */}
        <div
          className={`modal fade ${showDocumentsModal ? "show" : ""}`}
          style={{
            display: showDocumentsModal ? "block" : "none",
            background: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="patientDocumentsModalLabel"
          aria-hidden={!showDocumentsModal}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header py-2">
                <h6
                  className="modal-title text-dark"
                  id="patientDocumentsModalLabel"
                >
                  Patient Documents (
                  {appointments?.patients_details?.[0]?.patient_id || "N/A"})
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setShowDocumentsModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-3">
                {renderPatientDocumentsPanel()}
              </div>
            </div>
          </div>
        </div>
        {/* ===================== Patient Documents Modal ===================== */}
      </div>
    </>
  );
};

export default PrescriptionData;